export const localizationConstants = {
	welcome: 'Welcome',
	// welcomeMessage:
	//   'To MyPeegu Dashboard. Gain access to a comprehensive platform designed for administrators and counselors to effortlessly review student academics and much more.',
	welcomeMessage:
		"Unleashing the counselor's magic and the student's stardom ",
	signIn: 'Sign In',
	email: 'Email',
	emailMsg: 'Email Id of student',

	password: 'Password',
	forgotPassword: 'Forgot Password ?',
	login: 'Log In',
	enterEmail: 'Enter Email',
	enterPassword: 'Enter Password',
	accountRecovery: 'Account Recovery - Reset Your Password',
	accountRecoveryDescription:
		"Can't remember your password? Don't worry, we've got you covered. With our hassle-free account recovery process.",
	forgotPasswordTitle: 'Forgot Password',
	enterEmailAddress: 'Enter the email address associated with your account.',
	emailId: 'Email Id',
	createNewPassword: 'Create New Password',
	createNewPasswordMessage:
		'Create your new password now and continue your journey with MyPeegu Dashboard.',
	setupNewPassword: 'Set Up New Password',
	newPassword: 'New Password',
	confirmNewPassword: 'Confirm New Password',
	enterNewPassword: 'Enter New Password',
	submit: 'Submit',
	pageNotAvailable: 'The Page You Are Looking For is Not Available',
	linkIsExpired: 'Link is Expired',
	pleaseContactYourAdministratorToGetLink:
		'Please Contact your administrator to get link ',
	contactAdminSomethingWrong:
		'Sorry, something went wrong. Please contact Admin.',
	passwordsAreNotMatching: 'Passwords are not matching',
	dashboard: 'Dashboard',
	counsellors: 'Counsellors',
	academic: 'Academic',
	initiations: 'Initiations',
	schools: 'Schools',
	classrooms: 'Classrooms',
	classroom: 'Classroom',
	students: 'Students',
	observation: 'Observation',
	observationLog: 'Observation V2',
	individualCase: 'Individual Case',
	baseline: 'Baseline',
	SELCurriculumTracker: 'SEL Curriculum Tracker',
	logout: 'Logout',
	totalCounsellors: 'Total Counsellors',
	activeSchools: 'Active Schools',
	totalClasses: 'Total Classes',
	totalStudents: 'Total Students',
	trackAndManage:
		'Track and Manage Counsellors and Student Performance Attendance and Behavioral Metrics',
	fuelCouncelor: `Let’s enhance our counselling superpower !`,
	continue: 'Continue',
	passwordMustHave: 'Password must have:',
	aMinimumOfEightCharacters: 'A minimum of 8 characters',
	atLeastOneUpperCase: 'At least 1 upper case (A-Z)',
	atLeastOneLowerCase: 'At least 1 lower case (a-z)',
	atLeastOneDigit: 'At least 1 digit (0-9)',
	atLeastOneSpecialCharacter: 'At least 1 special character (!,@,#,*,_,-)',
	searchCounsellors: 'Search Counsellors',
	noCounsellorAdded: 'No Counsellor Added',
	noSchoolsAdded: 'No Schools Added',
	noClassroomsAdded: 'No Classrooms Added',
	noStudentsAdded: 'No Students Added',
	noObservationsAdded: 'No Observations Added',
	noIndividualCasesAdded: 'No Individual Cases Added',
	noBaselinesAdded: 'No Baselines Added',
	addNewCounsellor: 'Add New Counsellor',
	searchSchool: 'Search School',
	addSchool: 'Add School',
	addClassroom: 'Add Classroom',
	addStudent: 'Add Student',
	addObservation: 'Add Observation',
	addIndividualCase: 'Add Individual Case',
	addBaseline: 'Add Baseline',
	editSchool: 'Edit School',
	filterSchool: 'Filter School',
	add: '+  Add School',
	deleteSchool: 'Delete School',
	inActivateSchool: 'Are you sure you want to inactivate this school?',
	inActivateSchoolMsg:
		'All users associated with this school will lose access to its data. They will no longer be able to view or perform any actions related to this school. This action may disrupt any ongoing operations or workflows.',
	deleteSchoolMsg:
		'Deleting a school will permanently Delete it from list. The all stored data also will delete.',
	confirmInactivate: 'Yes, Inactivate',
	confirmDeactivate: 'Yes, Deactivate',

	confirmActivate: 'Yes, Activate',
	users: 'Users',
	hi: 'Hi,',
	addCounsellor: 'Add Counsellor',
	addUser: 'Add User',
	editUser: 'Edit User',
	deleteUser: 'Delete User',

	// SEL Curriculum Tracker — Super Admin
	
	selTemplateAdmin: 'SEL Template Setup',
	seladd: 'Manage SEL Templates',
	selAddTemplate: 'Add SEL Template',
	selEditTemplate: 'Edit SEL Template',
	selTemplatePrefillHint: 'Form pre-filled from admin template. You can edit before saving.',
	selTemplateNotFoundHint: 'No exact template match. Select the correct SEL Year / Month above, or ask admin to create one.',
	selTemplateMatchedHint: 'Template loaded for',
	selAutoFetchTitle: 'Auto Fetch Template',
	selAutoFetchHint: 'Select SEL Year, Month and Grade Band, then fetch the matching admin template. You can review and edit before saving.',
	selAutoFetchButton: 'Auto Fetch Template',
	selAutoFetchLoading: 'Fetching SEL template…',
	selAutoFetchSuccess: 'Template fetched successfully.',
	selAutoFetchNotFound: 'No matching SEL template was found for the selected Year, Month and Grade Band. You can continue with manual entry or create/configure a template in SEL Template Setup.',
	selYearLabel: 'SEL Year',
	selGradeBandLabel: 'Grade Band',
	selPeriod: 'Period',
	selectPeriod: 'Select Period',

	studentSelfAssessment: 'Student Self Assessment',
	// New Assessment Labels
	newAssessment: 'New Assessment',
	safeSpaces: 'Safe Spaces',
	selCompetency: 'SEL Competency Assessment',
	pulseDigitalWellbeing: 'Pulse (Digital Wellbeing)',
	heartEducators: 'HEART (Educators)',

	virtualCounselling: 'Virtual Counselling',
	safeSpaceSurvey: 'Safe Space Survey',
	sessions: 'Sessions',
	scheduleMeeting: 'Schedule Meeting',
	reports: 'Reports',
	// chatSupport: 'Chat Support',

	// Sub-labels & Descriptions
	grades3to5: 'Grades 3-5',
	grades6to12: 'Grades 6-12',
	educatorPsychologicalSafety: 'Educator Psychological Safety',
	digitalWellbeingCheckIn: 'Digital Wellbeing Check-In',

	// H.E.A.R.T Model Dimensions
	honesty: 'Honesty',
	empathy: 'Empathy',
	autonomy: 'Autonomy',
	respect: 'Respect',
	trust: 'Trust',

	// Safe Spaces Domains
	emotionalSafety: 'Emotional Safety',
	socialBelonging: 'Social Belonging',
	physicalSafety: 'Physical Safety',
	adultSupport: 'Adult Support',

	activateYourAccount: 'Activate Your Account - Set Up a New Password',
	welcomeAdmin:
		"Welcome, Counsellor ! It's time to activate your MyPeegu Dashboard account by setting up a new password.",
	activateAccount: 'Activate Account',
	or: 'or',
	orText: '------------- Search student by name above OR use filters below -------------',
	loginQuestion: 'Login ?',
	uhOh: 'Uh-oh!',
	yourPasswordResetLink:
		'Your password reset link has expired. Please begin again.',
	firstName: 'First Name *',
	lastName: 'Last Name',
	// emailId: 'Email Id *',
	emailIdOptional: 'Email Id',
	resend: 'Resend',
	enterFirstName: 'Enter First Name',
	enterLastName: 'Enter Last Name',
	enterEmailId: 'Enter Email ID',
	mobileNumber: 'Mobile Number *',
	mobileNumberOptional: 'Mobile Number',
	mobileNumMsg: 'Mobile Number of Teacher',
	enterMobileNumber: 'Enter Mobile Number',
	myPeegu: 'MyPeegu',
	school: 'School',
	assignSchool: 'Assign School',
	trackAndManageCounsellors:
		'Track & Manage Student Performance, Attendance, and Behavioral  Metrics.',
	filter: 'Filter',
	searchSchoolName: 'Search School Name',
	clear: 'Clear',
	apply: 'Apply',
	peeguCounsellor: 'PeeguCounselor',
	schoolCounsellor: 'ScCounselor',
	scPrincipal: 'ScPrincipal',
	assign: 'Assign',
	id: 'ID',
	name: 'Name',
	type: 'Type',
	schoolAssigned: 'School Assigned',
	number: 'Number',
	action: 'Action',
	left: 'left',
	editCounsellor: 'Edit Counsellor',
	edit: 'Edit',
	remove: 'Remove',
	deleteCounsellor: 'Delete Counsellor',
	deletingCounsellorMessage:
		'Deleting a user will permanently delete from Portal.',
	cancel: 'Cancel',
	yesDelete: 'Yes, Delete',
	yesSend: 'Yes, Send',
	invited: 'Invited',
	schoolName: 'School Name',
	scCode: 'School Code',
	city: 'City',
	onboardingDate: 'Onboarding Date',
	status: 'Status',
	active: 'Active',
	statusSmall: 'status',
	emailSmall: 'email',
	fullName: 'fullName',
	permissions: 'permissions',
	userId: 'user_id',
	phone: 'phone',
	Phone_no: 'Phone_no',
	Phone_noMsg: 'Phone No. of student',

	assignedSchools: 'assignedSchools',
	removeSchool: 'Remove School Access',
	removeSchoolMsg:
		'Removing a counsellor will permanently remove from Portal.',
	removeSchoolMsgInCounsellor:
		'Removing a School will permanently remove it from list.',
	yesRemove: 'Yes, Remove',
	inActive: 'In-Active',
	inactive: 'Inactive',
	schoolname: 'school',
	sccode: 'scCode',
	ciTy: 'city',
	onboardingdate: 'onboardDate',
	status_: 'status',
	establishedYear: 'Established Year',
	academicYear: 'Academic Year',
	schoolAcademicYear: 'School Academic Year',
	schoolAddress: 'School Address',
	state: 'State',
	Pincode: 'Pincode',
	dateOfOnboarding: 'Date of Onboarding',
	schoolWebsite: 'School Website',
	pricipal: 'Principal',
	aboutSchool: 'About School',
	enter: 'Enter',
	select: 'Select',
	year: 'Year',
	selectYear: 'Select Year',
	required: '*',
	schoolLogo: 'School Logo',
	uploadSchoolLogo: 'Upload Logo',
	changeSchoolLogo: 'Change Logo',
	allDates: 'All dates',
	today: 'Today',
	last7Days: 'Last 7 days',
	last30Days: 'Last 30 days',
	customDate: 'Custom date range',
	class: 'class',
	mobileNum: 'Mobile Number',
	studentsName: 'Student Name',
	studentsNameMsg: 'Name of the Student',
	className: 'Class Name',
	section: 'Section',
	registrationNumber: 'Registration Number',
	nationality: 'Nationality',
	nationalityMsg: 'Nationality of the Student',
	registrationDate: 'Registration Date',
	gender: 'Gender',
	dob: 'DOB',
	bloodGroup: 'Blood Group',
	blood_Group: 'Blood_group',

	fathersName: "Father's Name",
	fathersNameMsg: "Name of the student's Father",
	mothersNameMsg: "Name of the student's Mother",

	mothersName: "Mother's Name",
	studentNameCamel: 'studentName',
	sectionCamel: 'section',
	registrationNumberCamel: 'regNo',
	nationalityCamel: 'nationality',
	registrationDateCamel: 'registrationDate',
	genderCamel: 'gender',
	dobCamel: 'dob',
	bloodGroupCamel: 'bloodGrp',
	fathersNameCamel: 'fatherName',
	mothersNameCamel: 'motherName',
	classNameCamel: 'className',
	admin: 'Admin',
	superAdmin: 'SuperAdmin',
	uploadCsv: 'Upload CSV',
	editStudent: 'Edit Student',
	permission: 'permission',
	studentId: 'Student ID',
	studentCId: 'Student Id',
	studentName: 'Student Name',
	newStudent: 'New Student',
	regNo: 'Reg No.',
	// academicYear: 'Academic Year',
	academicYearMsg: 'Academic Year , Example : 2022-2023',

	emailCapitalId: 'Email ID',
	date: 'Date',
	delete: 'Delete',
	RegNo: 'Reg_no',
	browseTheFile: 'Browse The File',
	supportFile: 'Supports CSV, .xlsx & xls format files',
	downloadTemplate: 'Download template',
	schoolDetails: 'School Details',
	teacherName: 'Teachers Name',
	contact: 'Contact',
	
	enterStudentName: 'Enter Student Name',
	selectSchoolName: 'Select School Name',
	selectNewStudent: 'Select New Student',
	enterRegistrationNumber: 'Enter Registration Number',
	enterClassName: 'Enter Class Name',
	enterSection: 'Enter Section',
	selectAcademicYear: 'Select Academic Year',
	selectMonth: 'Select Month',
	selectGender: 'Select Gender',
	enterNationality: 'Enter Nationality',
	selectBloodGroup: 'Select Blood Group',
	enterFathersName: "Enter Father's Name",
	enterMothersName: "Enter Mother's Name",
	removeStudentMsg: 'Are you sure, you want to delete this student ?',
	deleteStudent: 'Delete Student',
	studentIdCreateMsg:
		'Student unique Identification number. Numbers and characters, special characters are not allowed, Example: 1000408',
	studentIdMsg:
		'Unique number from the student list. Must match an existing ID in the system.',

	classNameMsg:
		'Name of the class within the the school, Example: Grade I / 1 /2',
	sectionMsg: 'Section within the Class,Example:A / B',
	newStudentMsg: 'Y for Yes, and N for No',
	RegNoMsg: 'Registration No. of Student, Example: S-10512',
	regDate: 'Reg_date',
	dateFormatMsg: 'Date in format of dd-mm-yyyy',
	regDateFormatMsg: 'Date of Registration in format of dd-mm-yyyy',

	classRoomTableConstants: {
		schoolName: { label: 'School Name', key: 'school' },
		academicYear: { label: 'Academic Year', key: 'academicYear' },
		teacherName: { label: 'Teacher Name', key: 'teacherName' },
		contact: { label: 'Contact', key: 'phone' },
		section: { label: 'Sections', key: 'section' },
		className: { label: 'Class Name', key: 'className' },
		classHierarchy: { label: 'Class Hierarchy', key: 'classHierarchy' },
		sectionHierarchy: {
			label: 'Section Hierarchy',
			key: 'sectionHierarchy',
		},
		email: { label: 'Email', key: 'email' },
		studentsInClass: { label: 'Students in Class', key: 'studentCount' },
	},
	deleteClassroomMsg:
		'Deleting a Classroom will permanently Delete it from list. The all stored data also will delete.',
	instructions: 'Instructions',
	schoolNameInstructionMsg:
		"it's school code that are added in Mypeegu app, Example: G-10240224.",
	classNameInstructionMsg: 'Name of the Class, Example: Grade I / 1 / 2 .',
	sectionHierarchyInstructionMsg:
		'Hierarchical order of section (Numerical Input only) , Example: 1 / 2 / 3',
	classHeirarchyInstructionMsg:
		'Hierarchical order of class (Numerical Input only), Example: 1 / 2 / 3',

	sectionNameInstructionMsg: 'Sections inside a class Example: A / B',
	downloadTemplateReferMsg: 'to refer the required format',
	emailError: {
		invalid: 'Please enter a valid email id',
	},
	startTime: 'Start Time',
	endTime: 'End Time',
	issueReported: 'Issue Reported or Identified',
	issues: 'issues',
	goals: 'Goals',
	activity: 'Activity',
	description: 'Description',
	dimension: 'Dimension',
	basedOn: 'Based On',
	purpose: 'Purpose',
	outcome: 'Outcome',
	improvementAreas: 'Improvement Areas',
	comments: 'Comments',
	taskAssigned: 'Task Assigned',
	poa: 'POA for Follow-up/Next Session',
	addd: 'Add',
	student: 'Student',
	showCategoryActions: 'Show Category Actions',
	dateCamel: 'date',
	deleteStudentCaseLog: 'Delete Student Case Log',
	deleteStudentCaseLogMsg:
		'Deleting a student case log will permanently delete it from list. ',

	save: 'Save',
	searchStudent: 'Search Student by Name, ID',
	present: 'Present',
	needs: 'Needs',
	not: 'Not',
	needsImpovement: 'Need Improvements',
	notPresent: 'Not Present',

	duration: 'duration',
	punctuality: 'Punctuality',
	abilityToFollowGuidelines: 'Ability To Follow Guidelines',
	abilityToFollowInstructions: 'Ability To Follow Instructions',
	participation: 'Participation',
	completionOfTasks: 'Completion of Tasks',
	abilityToWorkIndependently: 'Ability to Work Independently ',
	incidentalNote: 'Incidental Note/ Additional Comment',
	appearance: 'Appearance',
	attitude: 'Attitude',
	speech: 'Speech',
	affect: 'Affect',
	thought: 'Thought',
	additionalCommentOrNote: 'Additional Comment/Note',
	doo: 'DOO',
	dooCamel: 'doo',
	behaviour: 'Behaviour',
	basicDetails: 'Basic Details',
	otherDetails: 'Other Details',
	classroomPresence: 'Classroom Presence',
	microMentalStatusExamination: 'Micro-Mental Status Examination',
	durationPascalCase: 'Duration',
	physical: 'Physical',
	social: 'Social',
	emotional: 'Emotional',
	cognitive: 'Cognitive',
	language: 'Language',
	physicalCamel: 'physical',
	emotionalCamel: 'emotional',
	cognitiveCamel: 'cognitive',
	socialCamel: 'social',
	languageCamel: 'language',
	superAdminn: 'Super Admin',
	mypeeguCounsellor: 'MyPeegu Counsellor',
	schoolCounsellorr: 'School Counsellor',
	baselineForm: 'Baseline Form',
	total: 'Total',
	downloadReport: 'Download Report',
	// ==========================================
	// VERSION 1 (V1) - PURANE QUESTIONS (For 2025-2026 and older)
	// ============================
	baselineQns_v1: {
		// Physical preSchool & 1st
		preschoolLowerKgPhysicalQn1:
			'Is able to walk up and down stairs without hol ding onto the railing, reciprocating (one foot on each step)',
		preschoolLowerKgPhysicalQn2:
			'Is able to imitate simple bilateral movements of limbs (e.g. arms up together)',
		preschoolLowerKgPhysicalQn3:
			'Can copy simple shapes, like a circle or square',
		preschoolLowerKgPhysicalQn4: 'Can feed self well with a spoon and fork',
		preschoolLowerKgPhysicalQn5:
			'Is active during class and field activities',
		preschoolLowerKgPhysicalQn6: 'Usually cares for own toilet needs',
		preschoolLowerKgPhysicalQn7:
			'Hygiene habits are developing. For example, the child washes his / her hand after eating, clothing is kept clean etc',

		// Social preSchool & 1st
		preschoolLowerKgSocialQn1:
			'Initiates or joins in play with other children',
		preschoolLowerKgSocialQn2:
			'Can take turns in games or while sharing materials',
		preschoolLowerKgSocialQn3:
			'Show some awareness of moral reasoning, such as “fairness”, and good or bad behavior',
		preschoolLowerKgSocialQn4:
			'Follow simple rules in games but will always want to win',
		preschoolLowerKgSocialQn5:
			'Can understand the idea of “mine” and “his” or “hers”',
		preschoolLowerKgSocialQn6: 'Can convey likes and dislikes',
		preschoolLowerKgSocialQn7: 'Asks for help when needed',

		// Emotional preSchool & 1st
		preschoolLowerKgEmotionalQn1: 'Can show attachment to one-two friends',
		preschoolLowerKgEmotionalQn2:
			'Can label basic emotions- happiness, sadness, fear and anger',
		preschoolLowerKgEmotionalQn3: 'Smooth separation from care givers.',
		preschoolLowerKgEmotionalQn4:
			'Understands when someone is hurt and comforts them',
		preschoolLowerKgEmotionalQn5:
			'Able to express basic emotions like happiness or sadness',
		preschoolLowerKgEmotionalQn6:
			'Can experience emotions even in imaginary situations like stories, make believe play etc',
		preschoolLowerKgEmotionalQn7:
			'Open to novel experiences / Can adapt to change',

		// Cognitive preSchool & 1st
		preschoolLowerKgCognitiveQn1:
			'Asks "why" questions to gain information',
		preschoolLowerKgCognitiveQn2:
			'Have an attention span of around 5 to 10 minutes',
		preschoolLowerKgCognitiveQn3:
			'Is able to remember name and basic details of self',
		preschoolLowerKgCognitiveQn4:
			'Counts and understands the idea of counting',
		preschoolLowerKgCognitiveQn5: 'Can name 4 colors',
		preschoolLowerKgCognitiveQn6: 'Follows basic instructions',
		preschoolLowerKgCognitiveQn7: 'Does puzzles with 4 or 5 pieces',

		// Language preSchool & 1st
		preschoolLowerKgLanguageQn1:
			'Sings a song or says a poem from memory such as the “Itsy Bitsy Spider” or the “Wheels on the Bus”',
		preschoolLowerKgLanguageQn2:
			'Tells stories that may be grammatically incorrect',
		preschoolLowerKgLanguageQn3:
			'Can listen and repeat sentences, words etc',
		preschoolLowerKgLanguageQn4:
			'Uses sentences with more than five words consistently',
		preschoolLowerKgLanguageQn5:
			'Is able to comprehend simple instructions',
		preschoolLowerKgLanguageQn6:
			'Can use language rather than tantrums or physical aggression to express displeasure',
		preschoolLowerKgLanguageQn7:
			'Describe events that have already happened e.g. "we went park"',

		// Upper kg & Grade 1
		upperKgGrade1PhysicalQn1:
			'Can open zip lock bags, containers and lunch boxes',
		upperKgGrade1PhysicalQn2:
			'Organization skills are developing. For example, the child keeps his/her bag / cubby organized',
		upperKgGrade1PhysicalQn3: 'Can color within the lines',
		upperKgGrade1PhysicalQn4:
			'Is able to produce all alphabets and numbers without any inverse writing',
		upperKgGrade1PhysicalQn5:
			'Is able to use energy in a sustained manner through the day ex: does not have energy outbursts and hyper behavior and/or is able to remain active till the latter half of the afternoon',
		upperKgGrade1PhysicalQn6: 'Able to keep self-neat and tidy',
		upperKgGrade1PhysicalQn7:
			'The child maintains eye contact while communicating',
		upperKgGrade1SocialQn1: 'Initiates friendships with peers',
		upperKgGrade1SocialQn2:
			'Prefers to play with playmates than playing alone',
		upperKgGrade1SocialQn3:
			'Is able to follow rules while involved in rule-based games',
		upperKgGrade1SocialQn4: 'Listens while others are speaking',
		upperKgGrade1SocialQn5:
			'Show independence and stands up for herself when facing conflict. (For example, the child might ask another child to stop knocking down the tower of blocks they are building.)',
		upperKgGrade1SocialQn6: 'A sense of competence in tasks is developing',
		upperKgGrade1SocialQn7:
			'Are motivated to learn new tasks and feel confident when praised',
		upperKgGrade1EmotionalQn1: 'Expresses a variety of emotions',
		upperKgGrade1EmotionalQn2:
			'Understands concepts of right and wrong e.g.: it’s wrong to hit others',
		upperKgGrade1EmotionalQn3:
			'Has developed greater self-control and impulse control, i.e., can wait for turns and is patient in situations',
		upperKgGrade1EmotionalQn4:
			'Is able to talk about self and express his/her likes and dislikes',
		upperKgGrade1EmotionalQn5:
			'Can explain causes and consequences of emotions e.g.: I was angry at him because he snatched my pencil',
		upperKgGrade1EmotionalQn6: 'Shows responsiveness to others needs',
		upperKgGrade1EmotionalQn7:
			'Confidence in own abilities starts developing',
		upperKgGrade1CognitiveQn1:
			'Is able to grasp concepts introduced in class',
		upperKgGrade1CognitiveQn2:
			'Is able to verbally provide a detailed account of events and situations',
		upperKgGrade1CognitiveQn3: 'Can follow 3-4 step directions',
		upperKgGrade1CognitiveQn4: 'Understands concept of time, date and day',
		upperKgGrade1CognitiveQn5:
			'Is able to answer who, what, when, where, and why questions',
		upperKgGrade1CognitiveQn6: 'Attends to tasks until completion',
		upperKgGrade1CognitiveQn7:
			'Is able to sit at a desk, follow teacher instructions, and independently do simple in-class assignments',
		upperKgGrade1LanguageQn1: 'Can narrate a simple story',
		upperKgGrade1LanguageQn2:
			'Demonstrates understanding of verbal instructions by recalling them and by responding appropriately to what was said',
		upperKgGrade1LanguageQn3: 'Speaks clearly',
		upperKgGrade1LanguageQn4: 'Can comprehend 3-4 step directions',
		upperKgGrade1LanguageQn5:
			'Is able to recognize / recall most of the alphabets',
		upperKgGrade1LanguageQn6: 'Can read simple 3-4 letter words',
		upperKgGrade1LanguageQn7:
			'Use sentences that are well formed. However, they may still have some difficulties with grammar. For example, saying "sheeps" instead of "sheep" or "goed" instead of "went".',

		// Grade 2 & 3
		grade2n3PhysicalQn1:
			'Able to perform extracurricular activities introduced in school - Dance, karate, yoga',
		grade2n3PhysicalQn2:
			'Is able to organize self and is able to keep their belongings in an orderly fashion',
		grade2n3PhysicalQn3:
			'Gradually making letters smaller, more well-spaced and well lined-up',
		grade2n3PhysicalQn4:
			'Speed of copying down of content from the board and during dictation is developing',
		grade2n3PhysicalQn5:
			'Is able to use energy in a sustained manner through the day ex: does not have energy outbursts and hyper behavior and/or is able to remain active till the latter half of the afternoon',
		grade2n3PhysicalQn6:
			'Is aware about body, hygiene, neat dressing, tidy physical appearance etc',
		grade2n3PhysicalQn7:
			'Appropriate body language while communicating with others. For example, the child maintains appropriate physical distance while communicating',
		grade2n3SocialQn1: 'Can cooperate in group settings and group games',
		grade2n3SocialQn2:
			'Begins to develop moral reasoning and adopt social customs (understand honesty, right from wrong, fairness, good and bad, respect)',
		grade2n3SocialQn3:
			'Learning about talking to their friends e.g. turn taking, negotiation, listening, how to start and finish a conversation acceptably',
		grade2n3SocialQn4:
			'Learning about how to be a good member of his class by sharing, helping each other, waiting for his/her turn, participating in class activities, and so on',
		grade2n3SocialQn5: 'Can stay on topic during discussions',
		grade2n3SocialQn6:
			'Manage a degree of independent work and organization',
		grade2n3SocialQn7:
			'Ability to share is developing. For example, the child willingly shares stationary or books with peers in need',
		grade2n3EmotionalQn1:
			'Is able to express emotions like jealousy or rage in socially acceptable ways',
		grade2n3EmotionalQn2:
			'Ability to control impulses while expressing emotions is developing',
		grade2n3EmotionalQn3: 'Enjoys helping others and taking responsibility',
		grade2n3EmotionalQn4: 'Is able to respond to other’s emotions',
		grade2n3EmotionalQn5:
			'Use of expressive behavior to modulate relationship dynamics (e.g., smiling while reproaching a friend)',
		grade2n3EmotionalQn6:
			'Uses a wide array of words or actions to demonstrate awareness and concern for what others are feeling',
		grade2n3EmotionalQn7:
			'Can handle frustration with fewer emotional outbursts and is able to discuss what is emotionally troubling',
		grade2n3CognitiveQn1: 'Is able to grasp concepts introduced in class',
		grade2n3CognitiveQn2: 'Asks questions to get more information',
		grade2n3CognitiveQn3:
			'Is able to sit at a desk, follow teacher instructions, and independently do simple in-class assignments',
		grade2n3CognitiveQn4:
			'Can follow multiple (5 step) instructions -  "please put your pencils away, put your books away, then wash your hands and open your lunch boxes"',
		grade2n3CognitiveQn5:
			'Has developed an ability to evaluate his/her own work and recognize errors',
		grade2n3CognitiveQn6:
			'Asks questions about various things to satisfy his/her curiosity',
		grade2n3CognitiveQn7:
			'Focuses on understanding the concepts rather than just rote learning',
		grade2n3LanguageQn1: 'Is able to build in-depth conversation',
		grade2n3LanguageQn2: 'Reading ability has developed',
		grade2n3LanguageQn3:
			'Uses correct spelling and applies spelling rules in their writing',
		grade2n3LanguageQn4:
			'Can control rate, pitch and volume of their speech',
		grade2n3LanguageQn5: 'Begins to implement grammar rules in writing',
		grade2n3LanguageQn6: 'Is able to comprehend multiple instructions',
		grade2n3LanguageQn7:
			'Understand more complicated language such as ‘first’, ‘last’, ‘might’, ‘may be’, ‘above’ and ‘in between’',

		// Grade 4 & 5
		grade4n5PhysicalQn1: 'Hey',
		grade4n5PhysicalQn2:
			'Is able to organize self and is able to keep their belongings in an orderly fashion',
		grade4n5PhysicalQn3: 'Maintains legibility of handwriting',
		grade4n5PhysicalQn4:
			'Is well coordinated while working with lab equipment’s or projects that require the use of fine skills',
		grade4n5PhysicalQn5:
			'Is able to use energy in a sustained manner through the day ex: does not have energy outbursts and hyper behavior and/or is able to remain active till the latter half of the afternoon',
		grade4n5PhysicalQn6: 'Maintains physical hygiene and health',
		grade4n5PhysicalQn7:
			'Maintains appropriate body language during conversations. For example, the child maintains appropriate physical proximity while communicating, carries a good posture while sitting and standing',
		grade4n5SocialQn1:
			'Starts to form stronger, more complex friendships and peer relationships',
		grade4n5SocialQn2:
			'Feels passionate about organized team and competitive games',
		grade4n5SocialQn3:
			'Initiates interactions and can sustain them confidently',
		grade4n5SocialQn4:
			'Shows interest in being more grown-up and able to begin tackling more responsibilities and routines',
		grade4n5SocialQn5: 'Develops an ability to seek positive attention',
		grade4n5SocialQn6:
			'Can resolve social problems such as fights with friends and siblings',
		grade4n5SocialQn7:
			"Begin to develop their own point of view, which is sometimes different from the teachers' ideas.",
		grade4n5EmotionalQn1:
			'Has gained a sense of empathy, which is understanding and being sensitive to the feelings of others',
		grade4n5EmotionalQn2:
			"Doesn't overreact to or exaggerate situations and can manage emotional excitement.",
		grade4n5EmotionalQn3: 'Is confident about own skills',
		grade4n5EmotionalQn4:
			'Generally dependable and can be trusted with basic responsibilities',
		grade4n5EmotionalQn5:
			'Is developing perseverance – but interests may be short-lived',
		grade4n5EmotionalQn6:
			'Ability to talk about self has developed. For instance, the child is able to answer questions like: What are your strengths, how do you feel when…',
		grade4n5EmotionalQn7:
			'Developed self-regulation skills. By this time, they are mature enough to understand when they should control their emotions and when they should express it',
		grade4n5CognitiveQn1:
			'Is able to make decisions considering what is right and wrong',
		grade4n5CognitiveQn2:
			'Is able to (but not necessarily does) concentrate and read for longer durations',
		grade4n5CognitiveQn3:
			'Curious about concepts of morality, love, trust, god, super power etc. or any other concept that’s not concrete.',
		grade4n5CognitiveQn4:
			'Follows fairly complex directions with little repetition',
		grade4n5CognitiveQn5:
			'Demonstrates understanding of grade level content material',
		grade4n5CognitiveQn6: 'Good at memorizing and recalling information',
		grade4n5CognitiveQn7:
			'Can listen critically (detects flaws in reasoning of others, questions validity of conclusions, evaluates)',
		grade4n5LanguageQn1:
			'Participates in conversations like debates, discussions and carries them out well',
		grade4n5LanguageQn2:
			'Can adjust choice of words and sophistication according to situations and settings e.g.: Uses more kind form of language while talking to a teacher than while talking to peers or while chatting to younger/elder students in the school',
		grade4n5LanguageQn3:
			'Writing is extended to writing descriptions, reports, journals, and letters',
		grade4n5LanguageQn4: 'Is able to summarize and restate ideas',
		grade4n5LanguageQn5:
			'Is able to give complex directions (for example: to get to my house, take a left on Pine street, then a quick right at Oak street and then another quick left at Fir street)',
		grade4n5LanguageQn6: 'Applies spelling rules in their writing',
		grade4n5LanguageQn7:
			'Able to understand and use abstract terms (such as “justice” and “freedom”)',

		// Grade 6 & 7
		grade6n7PhysicalQn1:
			'Displays clarity in and increased speed of handwriting',
		grade6n7PhysicalQn2:
			'Is able to organize self and is able to keep their belongings in an orderly fashion',
		grade6n7PhysicalQn3: 'Maintains legibility of handwriting',
		grade6n7PhysicalQn4:
			'Is able to carry self with good poise and stature',
		grade6n7PhysicalQn5:
			'Is able to use energy in a sustained manner through the day ex: does not have energy outbursts and hyper behavior and/or is able to remain active till the latter half of the afternoon',
		grade6n7PhysicalQn6:
			'The child is able to keep themselves odor free, and actively takes steps towards hygiene. Ex: washes hands and face after sports.',
		grade6n7PhysicalQn7: 'The child carries a confident body language',
		grade6n7SocialQn1:
			'Starts to form stronger, more complex friendships and peer relationships',
		grade6n7SocialQn2:
			'Can converse with people freely and is active in a group set up',
		grade6n7SocialQn3:
			'Challenges intellectual and social authority, but with respect',
		grade6n7SocialQn4:
			'Initiates interactions and can sustain them confidently',
		grade6n7SocialQn5:
			'Understands the need to assume responsibility for his or her own behavior and that there are consequences associated with one’s actions',
		grade6n7SocialQn6: 'Understands other people’s points of view',
		grade6n7SocialQn7:
			'Comfortable with all peers including that of opposite sex',
		grade6n7EmotionalQn1:
			'Tries to understand other’s emotions and offers empathy',
		grade6n7EmotionalQn2:
			'Adopts appropriate vocabulary while expressing emotions. For instance, the child would not use foul language when angry',
		grade6n7EmotionalQn3:
			'Seeks emotional support from peers or from trusted adults',
		grade6n7EmotionalQn4:
			'Is more self-confident in their speech, and have a emotional balance in situations of low self-confidence example: If the child has low confidence in working with a group, the child is still able pacify self and give it a try',
		grade6n7EmotionalQn5:
			'Can recognize personal strengths and weaknesses and apply their strengths while involved in activities',
		grade6n7EmotionalQn6: 'Begins to have role models and looks up to them',
		grade6n7EmotionalQn7: 'Are motivated to accomplish',
		grade6n7CognitiveQn1:
			'Can concentrate and persist on tasks that require vigilance',
		grade6n7CognitiveQn2:
			'Thinking now considers the future. The child can have thoughtful discussions about war, college, the economy, and their visions of what would make the world better',
		grade6n7CognitiveQn3:
			'Able to generate new ideas based on previous learning',
		grade6n7CognitiveQn4:
			'Is able to apply gained knowledge in real life situations',
		grade6n7CognitiveQn5:
			'Learns to recognize that current actions can have an effect on the future',
		grade6n7CognitiveQn6:
			'Begins to independently differentiate right from wrong and develops a conscience',
		grade6n7CognitiveQn7:
			'Can comprehend hidden and deeper meaning of the written material or material heard',
		grade6n7LanguageQn1:
			'Can perform well in discussions, debates, justifying opinions etc',
		grade6n7LanguageQn2:
			'Can easily swap between formal and informal communication',
		grade6n7LanguageQn3: 'Use long sentences; usually 7-12 words or more',
		grade6n7LanguageQn4:
			'Show advanced understanding of grammatical sequences; recognizes when a sentence is not grammatically correct',
		grade6n7LanguageQn5:
			'Gives appropriate examples/ references while having a conversation',
		grade6n7LanguageQn6:
			'Can accompany words with facial expressions and gestures for emphasis',
		grade6n7LanguageQn7:
			'Know how to use sarcasm. Know when others are being sarcastic to them',

		// Grade 8 & 9
		grade8n9PhysicalQn1:
			'High Speed, complexity and accuracy in fine motor skills ex: is able to adapt to quick notes/ jotting of points and or is able to make detailed craft work etc',
		grade8n9PhysicalQn2:
			'Is able to organize self and is able to keep their belongings in an orderly fashion',
		grade8n9PhysicalQn3:
			'Is able to carry self with good poise and stature',
		grade8n9PhysicalQn4:
			'The child has developed good appetite and is able to meet his/her nourishment requirements',
		grade8n9PhysicalQn5:
			'Is able to use energy in a sustained manner through the day ex: does not have energy outbursts and hyper behavior and/or is able to remain active till the latter half of the afternoon',
		grade8n9PhysicalQn6:
			'The child is able to keep themselves odor free, and actively takes steps towards hygiene. Ex: washes hands and face after sports.',
		grade8n9PhysicalQn7:
			'The child is comfortable with bodily changes reflected through confident body language',
		grade8n9SocialQn1:
			'Enjoys being in a group and chatting about informal topics',
		grade8n9SocialQn2:
			'The child is able to adopt social customs, understands honesty and respects all',
		grade8n9SocialQn3:
			'Is able to seek out conversations with adults(teachers) and is able to show a heightened level of formal talk',
		grade8n9SocialQn4:
			'Use problem-solving, negotiating and compromising skills with peers and does not always require adult supervision to solve conflicts',
		grade8n9SocialQn5:
			'Does activities which will give appreciation, feeling of accomplishment and recognition',
		grade8n9SocialQn6:
			'Challenges intellectual and social authority, but with respect',
		grade8n9SocialQn7: "Likes to and cares to understand others' opinions",
		grade8n9EmotionalQn1: 'Increased mood swings but manages them well',
		grade8n9EmotionalQn2: 'Tries to empathize with others',
		grade8n9EmotionalQn3:
			'Can manage doing most of the tasks independently without much stress',
		grade8n9EmotionalQn4:
			'Discusses feelings and emotions with peers or trusted adults',
		grade8n9EmotionalQn5:
			'Concerned about body image, looks, and clothes but is able to manage their emotional wellbeing',
		grade8n9EmotionalQn6:
			'Develops greater understanding of all kinds of relationships and takes efforts to have healthier relationships with everyone',
		grade8n9EmotionalQn7:
			'Can reflect on their own behaviors. For instance, the child might realize that they are being rude to their peers',
		grade8n9CognitiveQn1:
			'Is able to understand abstract and complex concepts like theorems, scientific principles, formulae etc',
		grade8n9CognitiveQn2:
			'Has increased global awareness. For instance, the child is able to participate in discussion involving topics out of his/her syllabus',
		grade8n9CognitiveQn3:
			'Is able to use research and content generation skills to cater to academic and co-curricular needs',
		grade8n9CognitiveQn4:
			'Understand the consequences of actions, not just today, but also in a more far-reaching way',
		grade8n9CognitiveQn5:
			'Develop a strong sense of right and wrong; make decisions based on following their conscience',
		grade8n9CognitiveQn6:
			'Is able to construct hypothetical solutions to a problem and evaluate which is best',
		grade8n9CognitiveQn7:
			'Understands when he/she has not understood the concept and needs to research more or ask an expert for help',
		grade8n9LanguageQn1:
			'Enjoys healthy arguments and can offer his/her own perspective with valid proofs for them',
		grade8n9LanguageQn2: 'Makes planned oral presentations',
		grade8n9LanguageQn3:
			'They comprehend abstract language, such as idioms, figurative language, and metaphors',
		grade8n9LanguageQn4:
			'Explanations may become more figurative and less literal',
		grade8n9LanguageQn5:
			'Know that they talk differently to friends than to teachers',
		grade8n9LanguageQn6:
			'Ability to swap from one topic to another while conversing',
		grade8n9LanguageQn7:
			'Develops mastery in using technical terms in his/her language according to the subject',

		// Physical 10 & 12
		grade10to12PhysicalQn1:
			'Does the child demonstrate speed and accuracy in fine and gross motor skills?',
		grade10to12PhysicalQn2:
			'Is able to organize self and is able to keep their belongings in an orderly fashion',
		grade10to12PhysicalQn3:
			'Is able to carry self with good poise and stature',
		grade10to12PhysicalQn4:
			'The child has developed good appetite and is able to meet his/her nourishment requirements',
		grade10to12PhysicalQn5:
			'Is able to use energy in a sustained manner through the day ex: does not have energy outbursts and hyper behavior and/or is able to remain active till the latter half of the afternoon',
		grade10to12PhysicalQn6:
			'The child is able to keep themselves odor free, and actively takes steps towards hygiene. Ex: washes hands and face after sports.',
		grade10to12PhysicalQn7:
			'Can healthily deal with body growth and changed physical appearance',
		grade10to12SocialQn1:
			'Developing more mature sense of right and wrong, good at solving social issues',
		grade10to12SocialQn2: 'Develops good persuasion skills',
		grade10to12SocialQn3:
			'Accepts failures and mistakes and takes responsibility for them',
		grade10to12SocialQn4:
			'Improved sportsman’s spirit encourages peers even when they are a competition',
		grade10to12SocialQn5:
			'Uses a mix of formal and sophisticated language when communicating with adults and is able to put across points with respect',
		grade10to12SocialQn6: 'Can handle conflicts with adults and peers',
		grade10to12SocialQn7:
			"Likes to and cares to understand others' opinions",
		grade10to12EmotionalQn1:
			'Can handle mood swings and emotional turmoil well (at times with assistance from peers)',
		grade10to12EmotionalQn2:
			"Takes cognizance of others' feelings and emotions",
		grade10to12EmotionalQn3:
			'Tries to build a higher and healthier self-esteem e.g.: takes efforts to excel in something so that he/she feels confident and good about own self, tries to overcome weaknesses so that the self-esteem is elevated',
		grade10to12EmotionalQn4:
			'Better sense of self identity- is aware of his/her own goals, needs, beliefs and ideals for self',
		grade10to12EmotionalQn5:
			'Greater interest in the opposite sex but manages the impulses well',
		grade10to12EmotionalQn6:
			'Develops greater understanding of all kinds of relationships and takes efforts to have healthier relationships with everyone',
		grade10to12EmotionalQn7:
			'feels comfortable in own skin; secure sense of self',
		grade10to12CognitiveQn1:
			'Can understand complex moral, philosophical and political concepts',
		grade10to12CognitiveQn2:
			'Better adaptation to increased school work due to improved skills in time management, organization, test preparation and memory',
		grade10to12CognitiveQn3:
			'Well-developed organization skills with regards to all aspects like academics, thoughts, relations etc',
		grade10to12CognitiveQn4:
			'Has increased global awareness. For instance, the child is able to participate in discussion involving topics out of his/her syllabus',
		grade10to12CognitiveQn5:
			'Likes to reason and is capable of independent thinking',
		grade10to12CognitiveQn6:
			'Develop a strong sense of right and wrong; make decisions based on following their conscience',
		grade10to12CognitiveQn7:
			'Begin to set their own goals for the future, take other’s opinions into account but make their own decisions',
		grade10to12LanguageQn1:
			'Skillful in using words, phrases, idioms, metaphors, words with multiple meanings and situation specific vocabulary',
		grade10to12LanguageQn2:
			'Can analyze articles, reports, various texts and can paraphrase the same well',
		grade10to12LanguageQn3:
			'Know that they talk differently to friends than to teachers',
		grade10to12LanguageQn4:
			'High persistence and grasp in listening skills',
		grade10to12LanguageQn5:
			'Enjoys healthy arguments and can offer his/her own perspective with valid proofs for them',
		grade10to12LanguageQn6:
			'Organization and richness in expressive oral and written communication',
		grade10to12LanguageQn7:
			'Understands and uses social etiquette of language',
	},

	// ==========================================
	// VERSION 2 (V2) - New QUESTIONS (For 2026-2027 and newer)
	// ==========================================
	baselineQns_v2: {
		// Physical preSchool & 1st
		preschoolLowerKgPhysicalQn1:
			'Walks up and down stairs alternating feet (may use railing if needed).',
		preschoolLowerKgPhysicalQn2:
			'Imitates simple bilateral movements (clapping patterns, both arms up).',
		preschoolLowerKgPhysicalQn3:
			'Copies a circle; attempts simple shapes such as cross or square.',
		preschoolLowerKgPhysicalQn4:
			'Feeds self using spoon and attempts fork with minimal spilling.',
		preschoolLowerKgPhysicalQn5:
			'Participates in movement activities and shows adequate stamina for age.',
		preschoolLowerKgPhysicalQn6:
			'Usually manages toileting with minimal assistance.',
		preschoolLowerKgPhysicalQn7:
			'Washes hands with reminders and participates in hygiene routines.',

		// Social preSchool & 1st
		preschoolLowerKgSocialQn1: 'Initiates or joins play with peers.',
		preschoolLowerKgSocialQn2:
			'Takes turns with adult support or reminders.',
		preschoolLowerKgSocialQn3:
			'Begins to understand simple rules and fairness when guided.',
		preschoolLowerKgSocialQn4:
			'Follows simple game rules but may struggle with losing.',
		preschoolLowerKgSocialQn5:
			'Understands basic possession (mine, yours).',
		preschoolLowerKgSocialQn6:
			'Expresses likes and dislikes verbally or through gestures.',
		preschoolLowerKgSocialQn7: 'Seeks help from adults when needed.',

		// Emotional preSchool & 1st
		preschoolLowerKgEmotionalQn1:
			'Shows preference for one or two friends.',
		preschoolLowerKgEmotionalQn2:
			'Identifies basic emotions (happy, sad, angry, scared).',
		preschoolLowerKgEmotionalQn3:
			'Separates from caregivers with minimal distress after settling time.',
		preschoolLowerKgEmotionalQn4:
			'Shows emerging empathy when others are upset.',
		preschoolLowerKgEmotionalQn5:
			'Expresses emotions appropriately using words, gestures, or behavior.',
		preschoolLowerKgEmotionalQn6:
			'Demonstrates emotions during pretend or story-based play.',
		preschoolLowerKgEmotionalQn7:
			'Adjusts to routine changes with adult reassurance.',

		// Cognitive preSchool & 1st
		preschoolLowerKgCognitiveQn1: 'Asks questions to seek information.',
		preschoolLowerKgCognitiveQn2:
			'Sustains attention in structured activity for 5–8 minutes.',
		preschoolLowerKgCognitiveQn3:
			'States own name and basic personal details.',
		preschoolLowerKgCognitiveQn4:
			'Counts objects up to 5 with one-to-one correspondence (with support).',
		preschoolLowerKgCognitiveQn5: 'Identifies at least 3–4 common colors.',
		preschoolLowerKgCognitiveQn6:
			'Follows one-step and some two-step instructions.',
		preschoolLowerKgCognitiveQn7: 'Completes simple puzzles of 4–6 pieces.',

		// Language preSchool & 1st
		preschoolLowerKgLanguageQn1:
			'Recites familiar rhymes or songs with prompts.',
		preschoolLowerKgLanguageQn2:
			'Narrates simple events or stories using short sentences.',
		preschoolLowerKgLanguageQn3: 'Repeats short sentences of 4–6 words.',
		preschoolLowerKgLanguageQn4:
			'Uses sentences of 4–6 words consistently.',
		preschoolLowerKgLanguageQn5:
			'Understands and responds to simple instructions.',
		preschoolLowerKgLanguageQn6:
			'Uses words or gestures to express needs instead of only crying or aggression.',
		preschoolLowerKgLanguageQn7:
			'Describes a recent event in simple phrases.',

		// Upper kg & Grade 1
		upperKgGrade1PhysicalQn1:
			'Independently opens and closes lunch boxes, containers, and zippers.',
		upperKgGrade1PhysicalQn2:
			'Keeps personal belongings organized with reminders.',
		upperKgGrade1PhysicalQn3:
			'Colors within boundaries with reasonable control.',
		upperKgGrade1PhysicalQn4:
			'Writes or copies most letters and numbers with emerging orientation accuracy.',
		upperKgGrade1PhysicalQn5:
			'Maintains activity and participation through the school day with typical movement breaks.',
		upperKgGrade1PhysicalQn6:
			'Maintains personal neatness (uniform, materials) with minimal reminders.',
		upperKgGrade1PhysicalQn7:
			'Shows appropriate attention to speaker (eye contact or body orientation).',
		upperKgGrade1SocialQn1:
			'Initiates or responds to peer interactions and friendships.',
		upperKgGrade1SocialQn2:
			'Prefers group play and cooperative activities.',
		upperKgGrade1SocialQn3:
			'Follows rules in structured games with minimal reminders.',
		upperKgGrade1SocialQn4:
			'Listens while others speak and waits for turn in conversation.',
		upperKgGrade1SocialQn5:
			'Uses words to express disagreement or assert needs during peer conflicts.',
		upperKgGrade1SocialQn6:
			'Attempts tasks independently and persists with encouragement.',
		upperKgGrade1SocialQn7:
			'Shows interest in learning new tasks and responds positively to encouragement.',
		upperKgGrade1EmotionalQn1:
			'Expresses a range of emotions appropriately.',
		upperKgGrade1EmotionalQn2:
			'Demonstrates understanding of basic rules and consequences.',
		upperKgGrade1EmotionalQn3:
			'Waits for turn and manages impulses in structured situations.',
		upperKgGrade1EmotionalQn4:
			'Describes personal preferences and experiences.',
		upperKgGrade1EmotionalQn5: 'Explains simple reasons for own emotions.',
		upperKgGrade1EmotionalQn6:
			'Shows empathy and responds to others’ feelings.',
		upperKgGrade1EmotionalQn7:
			'Shows confidence in familiar tasks and willingness to try new ones.',
		upperKgGrade1CognitiveQn1:
			'Demonstrates understanding of age-appropriate classroom concepts with support.',
		upperKgGrade1CognitiveQn2:
			'Verbally describes events in sequence with some detail.',
		upperKgGrade1CognitiveQn3:
			'Follows 2-3 step directions independently and attempts 4-step directions with support.',
		upperKgGrade1CognitiveQn4:
			'Understands basic concepts of time (today, yesterday, tomorrow; parts of day).',
		upperKgGrade1CognitiveQn5:
			'Answers who, what, when, where, and why questions.',
		upperKgGrade1CognitiveQn6:
			'Sustains attention and completes structured tasks with reminders if needed.',
		upperKgGrade1CognitiveQn7:
			'Works independently on simple tasks for short periods.',
		upperKgGrade1LanguageQn1:
			'Narrates a simple story with beginning, middle, or end elements.',
		upperKgGrade1LanguageQn2:
			'Understands and recalls verbal instructions accurately.',
		upperKgGrade1LanguageQn3:
			'Speech is mostly intelligible to unfamiliar listeners.',
		upperKgGrade1LanguageQn4:
			'Understands multi-step verbal instructions in familiar contexts.',
		upperKgGrade1LanguageQn5:
			'Recognizes most uppercase and lowercase letters.',
		upperKgGrade1LanguageQn6:
			'Reads simple phonetic words appropriate to grade level.',
		upperKgGrade1LanguageQn7:
			'Uses complete sentences with emerging grammatical accuracy.',

		// Grade 2 & 3
		grade2n3PhysicalQn1:
			'Participates in structured physical or extracurricular activities with coordination appropriate for age.',
		grade2n3PhysicalQn2:
			'Organises personal belongings and school materials independently.',
		grade2n3PhysicalQn3:
			'Demonstrates improving handwriting control, spacing, and alignment.',
		grade2n3PhysicalQn4:
			'Copies from board or text with improving speed and accuracy.',
		grade2n3PhysicalQn5:
			'Maintains attention and physical participation throughout the school day with typical breaks.',
		grade2n3PhysicalQn6:
			'Maintains personal hygiene and neat appearance appropriate for age.',
		grade2n3PhysicalQn7:
			'Demonstrates appropriate body language and personal space in communication.',
		grade2n3SocialQn1: 'Cooperates effectively in group tasks and games.',
		grade2n3SocialQn2:
			'Demonstrates understanding of fairness, honesty, and classroom norms.',
		grade2n3SocialQn3:
			'Participates in conversations using turn-taking, listening, and topic maintenance.',
		grade2n3SocialQn4:
			'Participates responsibly in classroom routines and group activities.',
		grade2n3SocialQn5: 'Maintains topic during short discussions.',
		grade2n3SocialQn6:
			'Works independently on tasks for reasonable periods and manages materials.',
		grade2n3SocialQn7:
			'Shares materials and resources willingly in classroom settings.',
		grade2n3EmotionalQn1:
			'Expresses a wider range of emotions in socially appropriate ways.',
		grade2n3EmotionalQn2:
			'Demonstrates improving impulse control in structured settings.',
		grade2n3EmotionalQn3:
			'Shows responsibility and willingness to help peers or adults.',
		grade2n3EmotionalQn4:
			'Recognizes and responds appropriately to others’ feelings.',
		grade2n3EmotionalQn5:
			'Uses appropriate verbal or nonverbal strategies to maintain peer relationships.',
		grade2n3EmotionalQn6:
			'Demonstrates empathy through words or supportive actions.',
		grade2n3EmotionalQn7:
			'Manages frustration with fewer outbursts and can discuss feelings with support.',
		grade2n3CognitiveQn1:
			'Demonstrates understanding of grade-appropriate academic concepts with guidance when needed.',
		grade2n3CognitiveQn2:
			'Asks relevant questions to clarify or extend learning.',
		grade2n3CognitiveQn3:
			'Completes simple assignments independently following instructions.',
		grade2n3CognitiveQn4:
			'Follows 3–4 step instructions independently and longer sequences with support.',
		grade2n3CognitiveQn5: 'Reviews own work and identifies simple errors.',
		grade2n3CognitiveQn6: 'Demonstrates curiosity and seeks explanations.',
		grade2n3CognitiveQn7:
			'Demonstrates attempts to understand concepts, not only memorize procedures.',
		grade2n3LanguageQn1:
			'Engages in conversations with multiple exchanges on a topic.',
		grade2n3LanguageQn2:
			'Reads grade-level text with emerging fluency and comprehension.',
		grade2n3LanguageQn3:
			'Applies common spelling patterns and attempts conventional spelling.',
		grade2n3LanguageQn4:
			'Modulates voice appropriately for classroom communication.',
		grade2n3LanguageQn5:
			'Uses increasingly accurate grammar in speaking and writing.',
		grade2n3LanguageQn6:
			'Understands and follows multi-step verbal instructions.',
		grade2n3LanguageQn7:
			'Understands positional and relational vocabulary.',

		// Grade 4 & 5
		grade4n5PhysicalQn1:
			'Participates actively and confidently in physical and movement activities.',
		grade4n5PhysicalQn2:
			'Independently organizes personal materials and workspace.',
		grade4n5PhysicalQn3:
			'Maintains legible handwriting across routine classroom tasks.',
		grade4n5PhysicalQn4:
			'Demonstrates coordination while handling tools, lab materials, or craft tasks.',
		grade4n5PhysicalQn5:
			'Sustains participation and attention throughout the school day with typical breaks.',
		grade4n5PhysicalQn6:
			'Maintains personal hygiene and neat appearance independently.',
		grade4n5PhysicalQn7:
			'Demonstrates appropriate posture, body language, and personal space during interactions.',
		grade4n5SocialQn1:
			'Forms stable friendships and maintains peer relationships.',
		grade4n5SocialQn2:
			'Participates in cooperative and competitive group activities appropriately.',
		grade4n5SocialQn3:
			'Initiates and sustains peer interactions confidently.',
		grade4n5SocialQn4:
			'Takes responsibility for assigned roles and classroom routines.',
		grade4n5SocialQn5:
			'Seeks recognition appropriately through participation or achievement.',
		grade4n5SocialQn6:
			'Uses strategies to resolve peer conflicts with minimal adult support.',
		grade4n5SocialQn7:
			'Expresses personal opinions respectfully, even when differing from others.',
		grade4n5EmotionalQn1:
			'Demonstrates empathy and understanding of others’ perspectives.',
		grade4n5EmotionalQn2:
			'Regulates emotional reactions in most classroom and peer situations.',
		grade4n5EmotionalQn3:
			'Demonstrates confidence in familiar skills and willingness to attempt new tasks.',
		grade4n5EmotionalQn4:
			'Completes responsibilities reliably with minimal reminders.',
		grade4n5EmotionalQn5:
			'Demonstrates persistence in tasks, even when they are challenging.',
		grade4n5EmotionalQn6:
			'Reflects on personal strengths, preferences, and feelings.',
		grade4n5EmotionalQn7:
			'Demonstrates age-appropriate self-regulation in expressing and managing emotions.',
		grade4n5CognitiveQn1:
			'Makes decisions considering rules, fairness, and consequences.',
		grade4n5CognitiveQn2:
			'Sustains attention and concentration for extended academic tasks.',
		grade4n5CognitiveQn3:
			'Shows curiosity about abstract or complex ideas and concepts.',
		grade4n5CognitiveQn4:
			'Follows multi-step or complex directions independently.',
		grade4n5CognitiveQn5:
			'Demonstrates understanding of grade-appropriate academic concepts.',
		grade4n5CognitiveQn6:
			'Recalls learned information and applies it in familiar contexts.',
		grade4n5CognitiveQn7:
			'Begins to evaluate information and ask questions about ideas or conclusions.',
		grade4n5LanguageQn1:
			'Participates actively in discussions and structured conversations.',
		grade4n5LanguageQn2:
			'Adjusts tone and language appropriately for different audiences.',
		grade4n5LanguageQn3:
			'Writes extended texts such as descriptions, reports, or journals.',
		grade4n5LanguageQn4: 'Summarizes and restates information accurately.',
		grade4n5LanguageQn5: 'Gives clear multi-step directions verbally.',
		grade4n5LanguageQn6:
			'Applies common spelling rules with increasing accuracy.',
		grade4n5LanguageQn7:
			'Understands and uses increasingly abstract vocabulary.',

		// Grade 6 & 7 (Currently V1 copied, update when new data is available)
		grade6n7PhysicalQn1:
			'Displays clarity in and increased speed of handwriting',
		grade6n7PhysicalQn2:
			'Is able to organize self and is able to keep their belongings in an orderly fashion',
		grade6n7PhysicalQn3: 'Maintains legibility of handwriting',
		grade6n7PhysicalQn4:
			'Is able to carry self with good poise and stature',
		grade6n7PhysicalQn5:
			'Is able to use energy in a sustained manner through the day ex: does not have energy outbursts and hyper behavior and/or is able to remain active till the latter half of the afternoon',
		grade6n7PhysicalQn6:
			'The child is able to keep themselves odor free, and actively takes steps towards hygiene. Ex: washes hands and face after sports.',
		grade6n7PhysicalQn7: 'The child carries a confident body language',
		grade6n7SocialQn1:
			'Starts to form stronger, more complex friendships and peer relationships',
		grade6n7SocialQn2:
			'Can converse with people freely and is active in a group set up',
		grade6n7SocialQn3:
			'Challenges intellectual and social authority, but with respect',
		grade6n7SocialQn4:
			'Initiates interactions and can sustain them confidently',
		grade6n7SocialQn5:
			'Understands the need to assume responsibility for his or her own behavior and that there are consequences associated with one’s actions',
		grade6n7SocialQn6: 'Understands other people’s points of view',
		grade6n7SocialQn7:
			'Comfortable with all peers including that of opposite sex',
		grade6n7EmotionalQn1:
			'Tries to understand other’s emotions and offers empathy',
		grade6n7EmotionalQn2:
			'Adopts appropriate vocabulary while expressing emotions. For instance, the child would not use foul language when angry',
		grade6n7EmotionalQn3:
			'Seeks emotional support from peers or from trusted adults',
		grade6n7EmotionalQn4:
			'Is more self-confident in their speech, and have a emotional balance in situations of low self-confidence example: If the child has low confidence in working with a group, the child is still able pacify self and give it a try',
		grade6n7EmotionalQn5:
			'Can recognize personal strengths and weaknesses and apply their strengths while involved in activities',
		grade6n7EmotionalQn6: 'Begins to have role models and looks up to them',
		grade6n7EmotionalQn7: 'Are motivated to accomplish',
		grade6n7CognitiveQn1:
			'Can concentrate and persist on tasks that require vigilance',
		grade6n7CognitiveQn2:
			'Thinking now considers the future. The child can have thoughtful discussions about war, college, the economy, and their visions of what would make the world better',
		grade6n7CognitiveQn3:
			'Able to generate new ideas based on previous learning',
		grade6n7CognitiveQn4:
			'Is able to apply gained knowledge in real life situations',
		grade6n7CognitiveQn5:
			'Learns to recognize that current actions can have an effect on the future',
		grade6n7CognitiveQn6:
			'Begins to independently differentiate right from wrong and develops a conscience',
		grade6n7CognitiveQn7:
			'Can comprehend hidden and deeper meaning of the written material or material heard',
		grade6n7LanguageQn1:
			'Can perform well in discussions, debates, justifying opinions etc',
		grade6n7LanguageQn2:
			'Can easily swap between formal and informal communication',
		grade6n7LanguageQn3: 'Use long sentences; usually 7-12 words or more',
		grade6n7LanguageQn4:
			'Show advanced understanding of grammatical sequences; recognizes when a sentence is not grammatically correct',
		grade6n7LanguageQn5:
			'Gives appropriate examples/ references while having a conversation',
		grade6n7LanguageQn6:
			'Can accompany words with facial expressions and gestures for emphasis',
		grade6n7LanguageQn7:
			'Know how to use sarcasm. Know when others are being sarcastic to them',

		// Grade 8 & 9 (Currently V1 copied, update when new data is available)
		grade8n9PhysicalQn1:
			'High Speed, complexity and accuracy in fine motor skills ex: is able to adapt to quick notes/ jotting of points and or is able to make detailed craft work etc',
		grade8n9PhysicalQn2:
			'Is able to organize self and is able to keep their belongings in an orderly fashion',
		grade8n9PhysicalQn3:
			'Is able to carry self with good poise and stature',
		grade8n9PhysicalQn4:
			'The child has developed good appetite and is able to meet his/her nourishment requirements',
		grade8n9PhysicalQn5:
			'Is able to use energy in a sustained manner through the day ex: does not have energy outbursts and hyper behavior and/or is able to remain active till the latter half of the afternoon',
		grade8n9PhysicalQn6:
			'The child is able to keep themselves odor free, and actively takes steps towards hygiene. Ex: washes hands and face after sports.',
		grade8n9PhysicalQn7:
			'The child is comfortable with bodily changes reflected through confident body language',
		grade8n9SocialQn1:
			'Enjoys being in a group and chatting about informal topics',
		grade8n9SocialQn2:
			'The child is able to adopt social customs, understands honesty and respects all',
		grade8n9SocialQn3:
			'Is able to seek out conversations with adults(teachers) and is able to show a heightened level of formal talk',
		grade8n9SocialQn4:
			'Use problem-solving, negotiating and compromising skills with peers and does not always require adult supervision to solve conflicts',
		grade8n9SocialQn5:
			'Does activities which will give appreciation, feeling of accomplishment and recognition',
		grade8n9SocialQn6:
			'Challenges intellectual and social authority, but with respect',
		grade8n9SocialQn7: "Likes to and cares to understand others' opinions",
		grade8n9EmotionalQn1: 'Increased mood swings but manages them well',
		grade8n9EmotionalQn2: 'Tries to empathize with others',
		grade8n9EmotionalQn3:
			'Can manage doing most of the tasks independently without much stress',
		grade8n9EmotionalQn4:
			'Discusses feelings and emotions with peers or trusted adults',
		grade8n9EmotionalQn5:
			'Concerned about body image, looks, and clothes but is able to manage their emotional wellbeing',
		grade8n9EmotionalQn6:
			'Develops greater understanding of all kinds of relationships and takes efforts to have healthier relationships with everyone',
		grade8n9EmotionalQn7:
			'Can reflect on their own behaviors. For instance, the child might realize that they are being rude to their peers',
		grade8n9CognitiveQn1:
			'Is able to understand abstract and complex concepts like theorems, scientific principles, formulae etc',
		grade8n9CognitiveQn2:
			'Has increased global awareness. For instance, the child is able to participate in discussion involving topics out of his/her syllabus',
		grade8n9CognitiveQn3:
			'Is able to use research and content generation skills to cater to academic and co-curricular needs',
		grade8n9CognitiveQn4:
			'Understand the consequences of actions, not just today, but also in a more far-reaching way',
		grade8n9CognitiveQn5:
			'Develop a strong sense of right and wrong; make decisions based on following their conscience',
		grade8n9CognitiveQn6:
			'Is able to construct hypothetical solutions to a problem and evaluate which is best',
		grade8n9CognitiveQn7:
			'Understands when he/she has not understood the concept and needs to research more or ask an expert for help',
		grade8n9LanguageQn1:
			'Enjoys healthy arguments and can offer his/her own perspective with valid proofs for them',
		grade8n9LanguageQn2: 'Makes planned oral presentations',
		grade8n9LanguageQn3:
			'They comprehend abstract language, such as idioms, figurative language, and metaphors',
		grade8n9LanguageQn4:
			'Explanations may become more figurative and less literal',
		grade8n9LanguageQn5:
			'Know that they talk differently to friends than to teachers',
		grade8n9LanguageQn6:
			'Ability to swap from one topic to another while conversing',
		grade8n9LanguageQn7:
			'Develops mastery in using technical terms in his/her language according to the subject',

		// Physical 10 & 12 (Currently V1 copied, update when new data is available)
		grade10to12PhysicalQn1:
			'Does the child demonstrate speed and accuracy in fine and gross motor skills?',
		grade10to12PhysicalQn2:
			'Is able to organize self and is able to keep their belongings in an orderly fashion',
		grade10to12PhysicalQn3:
			'Is able to carry self with good poise and stature',
		grade10to12PhysicalQn4:
			'The child has developed good appetite and is able to meet his/her nourishment requirements',
		grade10to12PhysicalQn5:
			'Is able to use energy in a sustained manner through the day ex: does not have energy outbursts and hyper behavior and/or is able to remain active till the latter half of the afternoon',
		grade10to12PhysicalQn6:
			'The child is able to keep themselves odor free, and actively takes steps towards hygiene. Ex: washes hands and face after sports.',
		grade10to12PhysicalQn7:
			'Can healthily deal with body growth and changed physical appearance',
		grade10to12SocialQn1:
			'Developing more mature sense of right and wrong, good at solving social issues',
		grade10to12SocialQn2: 'Develops good persuasion skills',
		grade10to12SocialQn3:
			'Accepts failures and mistakes and takes responsibility for them',
		grade10to12SocialQn4:
			'Improved sportsman’s spirit encourages peers even when they are a competition',
		grade10to12SocialQn5:
			'Uses a mix of formal and sophisticated language when communicating with adults and is able to put across points with respect',
		grade10to12SocialQn6: 'Can handle conflicts with adults and peers',
		grade10to12SocialQn7:
			"Likes to and cares to understand others' opinions",
		grade10to12EmotionalQn1:
			'Can handle mood swings and emotional turmoil well (at times with assistance from peers)',
		grade10to12EmotionalQn2:
			"Takes cognizance of others' feelings and emotions",
		grade10to12EmotionalQn3:
			'Tries to build a higher and healthier self-esteem e.g.: takes efforts to excel in something so that he/she feels confident and good about own self, tries to overcome weaknesses so that the self-esteem is elevated',
		grade10to12EmotionalQn4:
			'Better sense of self identity- is aware of his/her own goals, needs, beliefs and ideals for self',
		grade10to12EmotionalQn5:
			'Greater interest in the opposite sex but manages the impulses well',
		grade10to12EmotionalQn6:
			'Develops greater understanding of all kinds of relationships and takes efforts to have healthier relationships with everyone',
		grade10to12EmotionalQn7:
			'feels comfortable in own skin; secure sense of self',
		grade10to12CognitiveQn1:
			'Can understand complex moral, philosophical and political concepts',
		grade10to12CognitiveQn2:
			'Better adaptation to increased school work due to improved skills in time management, organization, test preparation and memory',
		grade10to12CognitiveQn3:
			'Well-developed organization skills with regards to all aspects like academics, thoughts, relations etc',
		grade10to12CognitiveQn4:
			'Has increased global awareness. For instance, the child is able to participate in discussion involving topics out of his/her syllabus',
		grade10to12CognitiveQn5:
			'Likes to reason and is capable of independent thinking',
		grade10to12CognitiveQn6:
			'Develop a strong sense of right and wrong; make decisions based on following their conscience',
		grade10to12CognitiveQn7:
			'Begin to set their own goals for the future, take other’s opinions into account but make their own decisions',
		grade10to12LanguageQn1:
			'Skillful in using words, phrases, idioms, metaphors, words with multiple meanings and situation specific vocabulary',
		grade10to12LanguageQn2:
			'Can analyze articles, reports, various texts and can paraphrase the same well',
		grade10to12LanguageQn3:
			'Know that they talk differently to friends than to teachers',
		grade10to12LanguageQn4:
			'High persistence and grasp in listening skills',
		grade10to12LanguageQn5:
			'Enjoys healthy arguments and can offer his/her own perspective with valid proofs for them',
		grade10to12LanguageQn6:
			'Organization and richness in expressive oral and written communication',
		grade10to12LanguageQn7:
			'Understands and uses social etiquette of language',
	},

	deleteStudentRecord: 'Delete Student Record',
	baselineDeleteMsg:
		'Deleting a Student will permanently Delete it from list.',
	of: 'of',
	rowsPerPage: 'Rows per page',
	uploadFile: 'Upload File',
	addSelTracker: 'Add SEL Tracker',
	coreCompetency: 'Core Competency',
	coreCompetencyCamel: 'CoreCompetency',
	topic: 'Topic',
	topicCamel: 'topic',
	commentsOrObservation: 'Comments/Observation',
	commentsOrObservationCamel: 'CommentsOrObservation',
	activityCamel: 'activity',
	noSelTrackerAdded: 'No SEL Tracker Added',
	searchClass: 'Search Class',
	outcomeCamel: 'outcome',
	taskAssignedOrReflection: 'Task Assigned/Reflection',
	taskAssignedOrReflectionCamel: 'taskAssignedOrReflection',
	ifAny: '(If any)',
	interventionsForEducators: 'Interventions for educators, if any',
	interventionsForEducatorsCamel: 'interventionsForEducatorsIfAny',
	followUpActivity: 'Follow Up Activity ',
	followUpActivityCamel: 'followUpActivityIfAny',
	addSELCurriculumTracker: 'Add SEL Curriculum Tracker',
	editdSELCurriculumTracker: 'Edit SEL Curriculum Tracker',
	viewSELCurriculumTracker: 'View SEL Curriculum Tracker',
	selInformation: 'SEL Information',
	dateOfInteraction: 'Date of Interaction',
	dateOfObservation: 'Date of Observation',
	deleteSEL: 'Delete SEL curriculum tracker',
	deleteSELMsg:
		'Deleting a SEL curriculum tracker will permanently delete it from list. ',
	baselineAnalyticsClickMsg:
		'*To get overall baseline analytics report of school data,click here',
	baselineAnalytics: 'Baseline Analytics',
	generateReport: 'Generate Report',
	totalStrength: 'Total Strength',
	overviewOfStudentInGreen: 'Overview of Student in "Green"',
	overviewOfStudentInOrange: 'Overview of Student in "Orange"',
	overviewOfStudentInRed: 'Overview of Student in "Red"',
	ClassCamel: 'Class',
	generalOverviewOfBaseline: 'Domain Performance Summary',
	domain: 'Domain',
	percentage: 'Percentage',
	zeroToThree: '0-3',
	fourToFive: '4-5',
	sixToSeven: '6-7',
	center: 'center',
	downloadAnalyticalPDFReport: 'Download Analytical PDF Report',
	downloadAnalyticalPDFReportMsg:
		'*To get the report please click download button',

	downloadTeacherIRIAnalyticalPDFReportMsg:
		'*To get overall teacher IRI Analytics report of School, please Click Download Button',
	downloadTeacherProfilingAnalyticalPDFReportMsg:
		'*To get overall teacher Profiling Analytics report of School, please Click Download Button',

	individualStudentBaselineReportPDFReportMsg:
		"*To get Individual Student's Baseline Report, please Click Download Button",

	individualStudentCOPEReportPDFReportMsg:
		"*To get Individual Student's COPE Report, please Click Download Button",

	individualStudentWellBeingReportPDFReportMsg:
		"*To get Individual Student's Well-Being Report, please Click Download Button",

	downloadTeacherProfilingAnalyticsForSpecificSchoolPDFReportMsg:
		'*To get specific School Profiling Analytics report, please select School and Click Download Button',
	downloadStudentCOPEAnalyticalPDFReportMsg:
		'*To get overall Student COPE Analytics report of School, please Click Download Button.',
	download: 'Download',
	overallBaselineSchools: 'Overall Baseline (Schools)',
	domainWisePerformance: 'Domain Wise Performance',
	resultAndDiscussion: 'Result and Discussion',

	baselineAnalyticsMsg: 'Explore Baseline Analytics Now !',
	schoolBaselineRank: 'School Baseline Rank',
	classRankInSchool: 'Class Rank in School',
	overallBaselineScore: 'Overall Baseline Score',
	outOf: 'Out of',
	schoolRankInCategories: 'School Rank in Categories',
	classRankInCategories: 'Class Rank in Categories',
	schoolProfile: 'School Profile',
	classProfile: 'Class Profile',
	// classRankInSchool: 'Class Rank in School',
	classes: 'Classes',
	sections: 'Sections',
	Class: 'Class',
	rankInSection: 'Rank in Section',
	rankInClass: 'Rank in Class',
	rankInSchool: 'Rank in School',
	domainWiseScore: 'Domain wise Score',
	studentScoreMaximumMark: 'Student Score (Maximum Mark 7)',
	mileStoneAchieved: 'Mile Stone Achieved',

	overall: 'Overall',
	baselineOneScore: 'Baseline 1 Score',
	studentCope: 'Student Cope',
	bulkUpload: 'Bulk Upload',
	noStudentCopeMsg: 'No Student COPE Assessment Available',
	noStudentWellBeingMsg: 'No Student Well Being Assessment Available',

	assessmentForm: 'Assessment Form ',
	notAtAllTrueForMe: 'Not at all true for me',
	reallyTrueForMe: 'Really true for me',
	counsellorName: 'Counsellor Name',
	update: 'Update',
	deleteStudentAssignmentReport: 'Delete Student Assignment Report',
	studentCopeAssessmentDeleteMsg:
		'Deleting a Student data will permanently Delete it from list. ',
	teacherIRIAssessmentDeleteMsg:
		'Deleting a Teacher data will permanently Delete it from list. ',
	AfterDeleteStudentCopeMsg:
		'No assignment data is available for selected student.',
	NoSchoolIRIAnalyticDataAvailable:
		'No IRI Analytic Data Available For Selected School.',
	NoIRIAnalyticDataAvailableForAY:
		'No IRI Analytic Data Available For Selected Academic Year.',
	NoIRIDataScheduled: `Teacher IRI's are not scheduled for the selected filters.`,

	NoSchoolProfilingAnalyticDataAvailable:
		'No Profiling Analytic Data Available For Selected School.',
	NoProfilingDataScheduled: `Teacher profiling's are not scheduled for the selected filters.`,
	NoProfilingAnalyticDataAvailableForAY:
		'No Profiling Analytic Data Available For Selected Academic Year.',
	deleteAlertMsg: 'No Records Added for this Student.',
	scCodeInstructionMsg:
		'scCode should match with the school codes that are added in Mypeegu app',
	dateOfAssessment: 'Date of Assessment',
	score: 'Score',
	questions: "Q's",
	scoreInstructionMsg: 'Numbers between 1 to 5',
	scoreInstructionMsgForTeacherIRI: 'Numbers between 0 to 4',
	scoreInstructionMsgForTeacherProfiling: 'Numbers between 1 to 5',
	scoreInstructionMsgForTeacherProfiling14: 'Numbers between 1 to 4',

	schoolLastPromoteAYerror:
		'upload is disabled because this school’s last active academic year is not up to date. Please mark students as exited or graduated, promote them to the next class, and shift sections if required. Once the school is updated to the current academic year, you can resume uploading',

	classGroup: 'Class Group',
	classGroupInstructionMsg:
		'Class group should match with the values given below',
	baselineCategoryInstructionMsg:
		'Baseline Category should match with the values given below',
	scoreInstructionMsg0or1:
		'PhysicalQns ,SocialQns ,EmotionalQns ,CognitiveQns , LanguageQns ,Values should be 0 or 1',
	teachers: 'Teachers',
	searchMsgTeachers: 'Search Teacher name or by ID',
	viewTeacher: 'View Teacher',
	editTeacher: 'Edit Teacher',
	deleteTeacher: 'Delete Teacher',
	deleteTeacherMsg:
		'Deleting a Teacher will permanently Delete it from list.',
	teachersId: 'Teachers ID',
	teacherId: 'Teacher ID',
	teacherFirstName: 'Teacher First Name',
	teacherLastName: 'Teacher Last Name',
	enterScCode: 'Enter School Code',
	male: 'Male',
	female: 'Female',
	all: 'All',
	teachersIdMsg:
		'Unique Id for Teachers. Maximum Character limit is 20. Special Characters are not allowed, Example : BPAT-01',
	teacherNameMsg: 'Name of the Teacher, Example : Rajesh Kumar.',
	teacherIdMsg: 'Id of the Teacher, Example : 08 or anything',
	TeacherLastNameMsg: 'Last name of Teacher',
	teacherEmailIdMsg: 'A valid email ID ,Example : rajeshkumar@gmail.com',
	teacherContactMsg: 'Teachers contact number',
	teacherSchoolCodeMsg:
		'School code as in Mypeegu application,Example : 	G-10240224',
	teachersEmail: 'Teacher’s Email',
	noTeachers: 'No Teachers',
	addTeacher: 'Add Teacher',
	enterTeacherName: 'Enter Teacher Name',
	deleteBulkInClassroomMsg:
		'Deleting a Classrooms will permanently Delete it from list. The all stored data also will delete.',
	deleteMultipleClassrooms: 'Delete Multiple Classrooms',
	deleteBulkInStudentMsg:
		'Deleting a Students will permanently Delete it from list.',
	deleteMultipleStudents: 'Delete Multiple Students',
	teacherInviteMessage: 'Send Invite to Teachers',
	teacherInviteMainMessage:
		'Send an activation link to teachers in their registered email',

	deleteMultipleObservation: 'Delete Multiple Student Observation',
	deleteBulkInObservationMsg:
		'Deleting a Students will permanently Delete it from list.',
	deleteMultipleIndividualCase: 'Delete Student Case Log',
	deleteBulkInIndividualCaseMsg:
		'Deleting a Student will permanently Delete it from list.',
	deleteMultipleBaseline: 'Delete Multiples Students Record',
	deleteBulkInBaselineMsg:
		'Deleting a Students will permanently Delete it from list.',
	deleteAlertBulkClassRoomMsg:
		'The selected classrooms have students. Please remove the student details to remove the class/section.',
	endtimeCannotBelessthanStartTime:
		'End time cannot be less than start time.',
	datesAreOverlapping:
		'Dates are over lapping with other school academic years.',
	baselineCategory: 'Baseline Category',
	assessment: 'Assessment',
	teacherIRI: 'Teacher IRI',
	scheduleIRI: 'Schedule IRI',
	IRIAnalytics: 'IRI Analytics',
	startDate: 'Start Date',
	endDate: 'End Date',
	totalTeachers: 'Total Teachers',
	iRISubmissiondate: 'IRI Submission Date',
	submissionDate: 'Submission Date',
	viewSchoolReport: 'View School Report',
	bloodgroupMsg: 'O+, O-, A+, A-, B+, B-, AB+, AB-',
	viewTeacherRecords: 'View Teacher Records',
	pending: 'Pending',
	submitted: 'Submitted',
	editScheduleErrorMsg: 'No Schedule Dates for this School,Schedule first',
	notSubmitted: 'Not submitted',
	scheduleStartDate: 'Schedule Start Date',
	scheduleEndDate: 'Schedule End Date',
	teacher: 'Teacher',
	studentCOPEAnalyticsReport: 'Student COPE Analytics Report',
	teacherIRIAnalyticsReport: 'Teacher IRI Analytics Report',
	uploadSELModules: 'Upload SEL Modules',
	getHere: 'Get Here',
	noRecordsScreenMsg: 'No assignment data is available for selected Teacher',
	noStudentCOPERecordsAvailable:
		'No assignment data is available for selected student',
	errorFileDownloadMsg:
		"Errors were found in the file. Please click on 'download' to see the error file.",
	closeCamel: 'Close',
	oops: 'Oops',
	IRIReport: 'IRI Report',
	IRIScore: 'IRI Score',
	copeReport: 'COPE Report',
	perspectiveTaking: 'Perspective Taking',
	vicariousEmpathy: 'Vicarious Empathy / Imagination',
	empathicConcern: 'Empathic Concern',
	altruisticReactivity: 'Altruistic Reactivity',
	DimensionWiseScore: 'Dimension Wise Score',
	Dimensions: 'Dimensions',
	percentileInSchool: 'Percentile in School',
	percentileAcrossSchool: 'Percentile across School',
	genderWiseReport: 'Gender Wise Report ( All Schools )',
	schoolRankInDimensions: 'School Rank in Dimensions',
	rank: 'Rank',
	schoolScore: 'School Score',
	topScore: 'Top Score',
	percentileScoreOfSchool: 'Percentile Score Of School',

	PerspectiveTakingScale: 'Perspective-Taking Scale',
	FantasyScale: 'Fantasy Scale',
	EmpathicConcernScale: 'Empathic Concern Scale',
	AltruisticReactivity: 'Altruistic Reactivity',

	domainWiseMale: 'Domain Wise ( Male )',
	domainWiseFemale: 'Domain Wise ( Female )',
	submittedTeacher: 'Submitted Teacher',
	pendingTeacher: 'Pending Teacher',
	copeAnalytics: 'COPE Analytics',
	emotionRegulation: 'Emotion Regulation',
	impulseControl: 'Impulse Control',
	resilience: 'Resilience',
	organization: 'Organization ',
	attention: 'Attention',
	componentWiseReport: 'Component Wise Report',
	shortTermRegulation: 'Short Term Regulation',
	LongTermRegulation: 'Long Term Regulation',
	overallSelfRegulation: 'Overall Self Regulation',
	scoreAmongstFiveDomains: 'Score amongst Five Domains',
	shortTerm: 'Short Term',
	longTerm: 'Long Term',
	meanValue: 'Mean Value',
	organisation: 'Organisation',
	shortTermScoreAverage: 'Short Term Score ( Average )',
	longTermScoreAvg: 'Long Term Score ( Average )',
	studentScoreComarisonTitle: 'Student Score Comparison with Mean in School',
	studentScoreAcrossSchollsComarisonTitle:
		'Student Score Comparison with Mean Across all Schools',
	identifiedStrength: 'Identified Strength',
	noData: 'No Data',
	needImprovement: 'Need Improvement',
	needSpecificSupport: 'Need Specific Support',
	totalSubmissionOfCOPE: 'Total Submission of COPE',
	studentAnalysisAllSchools: 'Student Analysis ( All Schools )',
	shortTermRegulationAvg: 'Short Term Regulation Avg',
	longTermRegulationAvg: 'Long Term Regulation Avg',
	COPEScoreAllSchools: 'COPE Score ( All Schools )',
	copeScoreAllClasses: 'COPE Score ( All Classes )',
	schoolRank: 'School Rank',
	copeSubmissionDate: 'COPE Submission Date',
	noDateAvailable: 'No Date available',
	noCopeScoreDataAvailabe: 'No COPE Scores Available For Selected School',
	noDomainWisePerDataAvailabe:
		'No Domain Wise Performance Available For Selected School',
	sendMail: 'Send Mail',
	deActivate: 'Deactivate',
	activate: 'Activate',
	ActivationMsg: 'You Sure To Activate',
	deActivationMsg: 'You Sure To Deactivate',
	noActiveFormsFound: 'No Active Forms Found',
	teacherGenderMsg: 'Gender Of Teacher, Example:Male/Female',
	studentGenderMsg: 'Gender Of Student, Example:M/F',
	studentBGMsg:
		"Blood Group of the student, Example: 'O+ ', 'O-', 'A + ', 'A - ', 'B + ', 'B - ', 'AB + ', 'AB - '.",

	afterIRISubMessage:
		'Congratulations. You have successfully submitted your IRI survey',
	afterProfilingSubMessage:
		'Congratulations. You have successfully submitted your Profiling survey',

	teacherIdMessage:
		'Unique number from the teacher list. Must match an existing ID in the system.',
	schoolCodeMsg:
		'School Code should match with the school codes that are added in the Mypeegu app',

	teacherProfiling: 'Teacher Profiling',
	analytics: 'Analytics',
	scheduleProfiling: 'Schedule Profiling',
	profilingReport: 'Profiling Report',
	teachingAttitudes: 'Teaching Attitudes',
	teachingPractices: 'Teaching Practices',
	jobLifeSatisfaction: 'Job-Life Satisfaction',
	DISCWisePerformance: 'DISC Wise Performance',
	dominance: 'Dominance',
	influence: 'Influence',
	steadiness: 'Steadiness',
	compliance: 'Compliance',
	teacherProfilingSubmission: 'Teacher Profiling Submission',
	AssessmentSubmission: 'Assessment Submission',
	byTeacher: 'by Teacher',
	attributeWiseScore: 'Attribute Wise Score',
	totalSubmissionOfAssessment: 'Total Submission of Assessment',
	DomainWisePerformanceAllSchools: 'Domain Wise Performance (All Schools)',
	teachingAttitude: 'Teaching Attitude',
	submission: 'Submission',
	DISCWisePerformanceAllSchools: 'DISC Wise Performance ( All Schools)',
	Schedule: 'Schedule',
	editScheduleProfiling: 'Edit Schedule Profiling',
	DeactivatingSchoolMsg: 'Deactivating a School will not part of Scheduled',
	discProfile: 'DISC Profiles',
	score4PtScale: 'Score (4 Pt. Scale)',
	score5PtScale: 'Score (5 Pt. Scale)',
	teacherStatus: 'Teacher Status',
	formStatus: 'Form Status',
	categorization: 'Categorization',
	searchPalceholderForCOPE: 'Search Student name or by ID',
	deleteTeacherAssessmentReport: 'Delete Teacher Assessment Form',
	teacherProfilingAssessmentDeleteMsg:
		'Deleting a Teacher Assessment will permanently Delete it from list.',
	percentile: 'Percentile',
	DISC: 'DISC',
	AverageRratingAcrossQuestions: 'Average rating across questions',
	densityProportionMsg: 'Density ( Proportion of total)',
	cancelConfirmationMsg: 'Are you sure you want to Quit',
	yes: 'Yes',
	confirmation: 'Confirmation',
	studentWellBeing: 'Student Well-Being',
	report: 'Report',
	psychologicalWBScale: 'Psychological Well-Being scale',
	psychologicalWBScaleBulkUploadTitle:
		"Psychological Well-Being scale, PWB Q's",
	childrenHopeScale: "Children's Hope Scale",
	childrenHopeScaleBulkUploadTitle: "Children's Hope Scale, CHS Q's",
	alloftheTime: 'All of the time',
	noneoftheTime: 'None of the time',
	age: 'Age',
	overAllScore: 'Overall Score',
	scoreAmongstDomains: 'Score amongst Domains',
	pathway: 'Pathway',
	agency: 'Agency',
	// autonomy: 'Autonomy',
	environmental: 'Environmental',
	personalGrowth: 'Personal growth',
	positiveRelationswithOthers: 'Positive relations with others',
	purposeinlife: 'Purpose in life',
	SelfAcceptance: 'Self-acceptance',
	studentScoreComparisonwithMeaninSchool:
		'Student Score Comparison with Mean in School',
	studentScoreComparisonwithMeaninAllSchool:
		'Student Score Comparison with Mean Across all Schools',
	categorizationOverallHopeCHS: 'Categorization Overall Hope (CHS)',
	categorizationOverallHopePWB: 'Categorization Overall Hope (PWB)',
	moderatelyHopeful: 'Moderately Hopeful',
	highlyHopeful: 'Highly Hopeful',
	slightlyHopeful: 'Slightly Hopeful',
	notoVeryLowHope: 'No to Very Low Hope',
	totalSubmission: 'Total Submission',
	high: 'High',
	moderate: 'Moderate',
	urgent: 'Urgent',
	chsInstructionMsg: 'Number between 1 to 6',
	pwbInstructionMsg: 'Number between 1 to 7',
	stronglyDisagree: 'Strongly Disagree',
	stronglyAgree: 'Strongly Agree',
	downloadStudentWellBeingAnalyticalPDFReportMsg:
		'*To get overall Student Well Being Analytics report of School, please Click Download Button.',
	allClasses: 'All Classes',
	sendChecklist: 'Send Checklist',
	fineMotorGrossMotorSkill: 'Fine Motor and Gross Motor Skill',
	behavior: 'Behavior ',
	attentionHyperactivity: 'Attention and Hyperactivity',
	memory: 'Memory',
	readingAndSpelling: 'Reading & Spelling',
	numeracySkills: 'Numeracy Skills',
	speakingAndListening: 'Speaking And Listening',
	styleofWorking: 'Style of Working',
	sendChecklistForm: 'Send Checklist Form',
	fineMotorGrossMotorSkillPGC:
		'Fine Motor and Gross Motor Skill (Posture, Gait and Coordination)',
	socialSkills: 'Social Skills',
	visualAndPerceptualAbility: 'Visual And Perceptual Ability',
	overallTotal: 'Overall Total',

	editSchoolDetails: 'Edit School Details',
	schoolAcademicYears: 'School Academic Years',
	promoteStudents: 'Promote Students',
	shiftSections: 'Shift Sections',
	markStudentsasGraduate: 'Mark Students as Graduate',
	markStudentsasExited: 'Mark Students as Exited',
	promoteStudentsMsg:
		'Promoting the class students will move all students to the next academic level. Are you sure you want to proceed ?',
	cannotUpdateDetails: 'Cannot Update Student Details',
	promoteStudentsToCurAY:
		'Please promote the school to the current academic year before updating student class information. Updates are only allowed if the active academic year is the current one.',
	yesPromote: 'Yes, Promote',
	shiftSection: 'Shift Section',
	fromSection: 'From Section',
	selectSection: 'Select Section',
	toSection: 'To Section',
	red: 'Red',
	green: 'Green',
	orange: 'Orange',
	ValueShouldbeYesorNo: 'Value Should be Yes or No',
	MarkasGraduated: 'Mark as Graduated',
	MarkStudentAsGraduated: 'Mark student as Graduated',
	MarkStudentAsExited: 'Mark student as Exited',

	MarkasExited: 'Mark as Exited',
	studentStatus: 'Student Status',
	graduated: 'Graduated',
	exited: 'Exited',
	promoteSingleStudentGraduatedMsg:
		'Are you sure, you want to mark this student as graduated?',
	promoteSingleStudentExitedMsg:
		'Are you sure, you want to mark this student as Exited?',
	noStudentChecklistMsg: 'No Student Checklist Available',
	value: 'value',
	valueMsg: 'Value Should be Yes or No',
	iep: 'IEP',
	bip: 'Behaviour Intervention Plan',
	gandt: 'G&T',
	evolution: 'Evaluation',
	longTermGoal: 'Long Term Goals',
	shortTermGoal: 'Short Term Goals',
	accommodationfromBanch: 'Accommodation (From Board)',
	accommodationInternal: 'Accommodation (Internal)',
	transitionPlanning: 'Transition Planning',
	individualSession: 'Individual Session',
	groupSession: 'Group Session',
	noStudentIEPMsg: 'No Student IEP Available',
	presentLevelofPerformanceAbilities:
		'Present Level of Performance & Abilities (From Baseline1)',
	additionalNeedsFromSendChecklist: 'Additional Needs (From Send Checklist)',
	placementWithSEND: 'Placement with SEND',
	sendChecklistDatanotFound: 'Send Checklist Data not Found',
	sendChecklistDatanotFoundMsg:
		'Please make sure to add send checklist data for this student to continue with IEP.',
	linguistic: 'Linguistic',
	category: 'Category',
	addComments: 'Add Comments',
	viewMore: 'View more...',
	viewless: 'View less...',
	editComments: 'Edit Comments',
	enterTheComment: 'Enter the comment *',
	session: 'Session Management',
	eligibility: 'Eligibility',
	frequencyPerWeek: 'Frequency (Per Week)',
	individual: 'Individual',
	group: 'Group',
	details: 'Details',
	requirement: 'Requirement',
	certificate: 'Certificate',
	regionalOffice: 'Regional Office',
	selectAccomodationApplicable: 'Select Accomodation Applicable',
	viewCircular: 'View Circular',
	diagnosis: 'Diagnosis',
	reportLink: 'Report Link',
	iEPUploadfileMsg: 'Support Jpeg, JPG, Pdf format files',
	iEPGoalsMsg:
		'Please make sure to add at least 1 short term & 1 long term Goals',
	shortTermGoalph: 'Describe the short term goal for student *',
	longTermGoalph: 'Describe the long term goal for student *',
	uploadReport: 'Upload Report',
	view: 'View',
	replaceReport: 'Replace Report',
	deleteReport: 'Delete Report',
	specialEducationClasses: 'Special Education Classes',
	behavioralInterventions: 'Behavioral Interventions',
	oneToOneWithHRT_CT: '1-1 w/ HRT/CT',
	focusClasses: 'Focus Classes/Remedial/Academic',
	accomondationsInSchool: 'Accomondations in the School',
	assistiveTechnology: 'Assistive Technology',
	communityExperience: 'Community Experience',
	activitiesofDailyLiving: 'Activities of Daily Living',
	functionalVocationalAssistance: 'Functional/ Vocational Assistance',
	availability: 'Availability',
	addGoals: 'Add Goals',
	addShortTermGoals: '+ Short term Goal',
	addLongTermGoals: '+ Long term Goal',
	iEPDetails: 'IEP Details',
	noDataFound: 'No Data Found',
	upload: 'Upload',
	deleteStudentsIepRecords: 'Delete Student IEP Record ',
	deleteStudentIEPMsg:
		'Deleting a Student IEP Record will permanently delete it from list. ',
	dataResetAlert: 'Data Reset Alert',
	dataResetAlertMsg:
		'Updating the student information will reset all current data entries below. Are you sure you want to proceed?',
	cbse: 'CBSE',
	icse: 'ICSE',
	chooseCircular: 'Choose Circular',
	selectSections: 'Select Sections',
	School: 'School',
	phoneNoTeacher: 'Phone No. of teacher',
	studentsNotSelectedError: 'Please select atleast one student to continue.',
	invalidEmail: 'Please enter a valid email.',
	invalidPhone: 'Please enter a valid 10 digit phone number.',
	noChanges:
		'You have not made any changes. Please modify some data to proceed.',
	errorData: 'There are some errors in the data you are trying to save.',
	country: 'Country',
	states: 'States',
	editSchoolAcademicYear: 'Edit School Academic Year',
	classroomSearchPlaceholder:
		'Search classrooms by school name, class name, section anme, teacher name, email or phone',
	reset: 'Reset',
	notApplicable: 'N/A',
	page: 'Page',
	viewSel: 'View SEL',
	cbseCircular: 'CBSE Circular',
	icseCircular: 'ICSE Circular',
	evaluationReport: 'Evaluation Report',
	byDate: 'By Date',
	role: 'Role',
	studentSearchPlaceholder:
		'Search student by Id, name, school name or reg number',
	observationSearchPlaceholder: 'Search by student name or by ID',
	markAsGraduateTitle: 'Are you sure you want to graduate these students?',
	markAsGraduateSubTitle:
		'Please double-check if any new classes are being added this year before proceeding.',
	markAsExitTitle: 'Are you sure you want to exit these students?',
	markAsExitSubTitle: 'Please double-check details before proceeding.',
	shiftSectionTitle:
		'Are you sure you want to shift section for these students?',
	shiftSectionSubTitle: 'Please double-check details before proceeding.',
	// promoteStudentWarning: 'promoteStudentWarning',
	// promoteStudentError: 'promoteStudentError',
	// shiftSubmitWarning: 'shiftSubmitWarning',
	// graduateError: 'graduateError',
	// graduateSubmitWarning: 'graduateSubmitWarning',
	// exitSubmitWarning: 'exitSubmitWarning',
	// classroomUploadWarning: 'classroomUploadWarning',
	// studentUploadWarning: 'studentUploadWarning',
	// teacherUploadWarning: 'teacherUploadWarning',
	// baselineUploadWarning: 'baselineUploadWarning',
	// sendchecklistUploadWarning: 'sendchecklistUploadWarning',
	bulkUploadWarning: 'bulkUploadWarning',
	graduateExitShiftWarning: 'graduateExitShiftWarning',
	alertGraduate: 'alertGraduate',
	alertPromotion: 'alertPromotion',
	promoteStudentWarning: 'promoteStudentWarning',

	markAsExitNote:
		'Use this option to mark students who are leaving the school for any reason. Please ensure you are selecting only those students who are actually exiting, as this action will remove them from the promotion and graduation process.',
	shiftSectionNote:
		'Before shifting sections, ensure classrooms are updated and all students are exited, graduated, or promoted as needed; shifting sections without completing these steps may result in incorrect section assignments for the academic year.',
	ifStudentsOf: 'If students of',
	areMeantToBe: 'are meant to be promoted but their next class for',
	hasNotBeCreatedYet:
		'has not been created yet, please add those classes and avoid graduating them. Otherwise, you can select and mark the students as graduated.',
	note: 'Note',
	promotingThe: 'Promoting the',
	studentsTo: 'students to',
	beforeProceedingEnsureAllClassroomsFor:
		'Before proceeding, ensure all classrooms for',
	areCreatedOrUpdated:
		'are created or updated, and students who should graduate or exit are marked accordingly',
	studentsNotMarkedASGraduated:
		'Students not marked as graduated or exited will be promoted to the next class. If no next class is found, they will be auto-graduated.',

	incorrectSetupMayLeadToDataIssues:
		'⚠️ Incorrect setup may lead to data issues. Proceed only after verifying all details.',
	ok: 'OK',
	alertPromotionMessage:
		'You cannot promote students for this school, as the promotion was already completed on',
	alertGraduateMessage:
		'The last promoted academic year for this school is the current year, which means there are no students eligible for graduation. Please perform this action in the next academic year.',
	graduateExitShiftWarningMessage:
		'Please review your selections carefully before submitting. This action will update student records and	cannot be undone. Ensure all related data (classrooms,	promotions, exits, graduations) is properly set to avoid inconsistencies.',
	bulkUploadWarningMessage:
		'Please verify that the Excel file is correctly filled and matches the required format. Uploading incorrect or incomplete data may result in errors or invalid records	being saved. Ensure all fields are accurate before proceeding.',
	selectSchool: 'Select School',
	graduateAlerttitle: 'No students to graduate',
	promoteAlertTitle: 'Student promotion already completed',
	selectClassRooms: 'Select Classrooms',
	cannotGraduate: 'Cannot graduate this student!',
	cannotGraduateDes:
		'The last promoted academic year for this school is the same as the current academic year. As a result, this student is not eligible for graduation at this time.',
	singleStudentGraduateAlert: 'singleStudentGraduateAlert',
	teacherUpdateAcknowledgement: 'teacherUpdateAcknowledgement',
	teacherUpdateAcknowledgementMess:
		'The classroom you’ve selected is already assigned to a different teacher. If you proceed with this update, the previous teacher’s assignment to this classroom will be removed along with their associated records.',
	selModuleUploadAcknowledgement: 'selModuleUploadAcknowledgement',
	selModuleUploadAcknowledgementMsg:
		'Sel module already exist for the same month and year. Uploading again will remove the existing SEL module data',
	areYouSureYouWantToUpdate: 'Are you sure, you want to update ?',
	areYouSureYouWantToUpload: 'Are you sure, you want to upload ?',
	noDataAvailable: 'No Data Available',
	selTracker: 'SEL Tracker',
	month: 'Month',
	Add: 'Add',
	IEP: 'IEP',
	circular: 'Circular',
	pleaseWaitForAdminToUpdate: 'Please wait for the admin to Add.',
	classroomConflictDetected: 'Classroom Already Assigned',
	selModuleAlreadyExist: 'SEL module already exist',
	lastActiveAcademicYear: 'Last Active Academic Year',
	lastPromotionAcademicYear: 'lastPromotionAcademicYear',
	selModuleExistForSelectedMonthYear: 'selModuleExistForSelectedMonthYear',

	currentAcademicYear: 'Current Academic Year',
	editingIsRestricted:
		'Editing is restricted for academic years before the last active year',
	clickToEditAY: 'Click to edit this academic year',
	
	editTeacherData: 'Edit Teacher Data',
	editTeacherClassrooms: 'Edit Teacher Classrooms',
	teacherAcademicClassrooms: 'Teacher Academic Classrooms',
	noClassroomsDataAvailable: `No classroom's data available`,
	validRows: 'Valid Rows: ',
	invalidRows: 'Invalid Rows: ',
	validCollumns: 'Valid Collumns: ',
	invalidCollumns: 'Invalid Collumns: ',
	invlaidExcelFile:
		'The uploaded Excel file is invalid or empty. Please check the file and re-upload.',
	editScheduleProfilingMsg:
		'Edit Schedule Profiling allowed only for Current Year.',
	editScheduleIRIMsg: 'Edit Schedule IRI allowed only for Current Year.',
	studentReport: 'Student Report',
	downloadStudentReport: 'Download Students Report',
	iriReport: 'IRI Report',
	discReport: 'DISC Report',

	// Baseline Analytics - Principal Friendly Labels
	screeningCompletionRate: 'Screening Completion Rate',
	studentSupportLevels: 'Student Support Levels',
	developmentalReadinessScore: 'Developmental Readiness Score',
	developmentalDomainPerformance: 'Developmental Domain Performance',
	meetingExpectations: 'Meeting Expectations',
	developingModerateSupport: 'Developing (Moderate Support)',
	needsIntensiveSupport: 'Needs Intensive Support',
	studentsAtRisk: 'Students At Risk',
	strongestDomain: 'Strongest Domain',
	focusArea: 'Focus Area',
	classWiseOverview: 'Class-wise Overview',
	schoolReadinessComparison: 'School Readiness Comparison',
	studentsMeetingExpectations: 'Students Meeting Expectations',
	studentsDeveloping: 'Students Developing',
	studentsNeedingSupport: 'Students Needing Intensive Support',
	screened: 'Screened',
	notScreened: 'Not Screened',
	assessedStudents: 'Assessed Students',
	totalEnrollment: 'Total Enrollment',
	domainWiseStudentDistribution: 'Domain-wise Student Distribution',
	supportLevelDistribution: 'Support Level Distribution',
	kpiSummary: 'Summary',

	// New Analytics Features
	genderDistribution: 'Gender Distribution',
	studentsAcrossClasses: 'Students Across Classes',
	riskDashboard: 'Risk Dashboard',
	advancedFilters: 'Advanced Filters',
	atRiskStudents: 'At-Risk Students',
	redDomains: 'Red Domains',
	exportToExcel: 'Export to Excel',
}
